import antd from 'ant-design-vue/lib/locale-provider/en_US'
import validation from 'vee-validate/dist/locale/id.json'

export default {
  language: 'Language',
  common: {
    back: 'Back',
    save_changes: 'Save Changes',
    email: 'Email',
    username: 'Username',
    page_not_found_msg: 'Sorry, the page you visited does not exist.',
    cancel: 'Cancel',
    close: 'Close',
    wait: 'Please wait...',
    ok: 'OK',
    no_data: 'No data',
    save: 'Save',
    add: 'Add',
    submit: 'Submit',
    coming_soon: 'Coming Soon',
    error_occurred: 'Something went wrong',
    total_items: 'Total {total} items',
    sku: 'SKU',
    name: 'Name',
    quantity: 'Quantity',
    uom: 'UOM',
    description: 'Description',
    time: 'Time',
    user: 'User',
    attachment: 'Attachment',
  },
  pageTitles: {
    dashboardAdmin: 'Powerbiz - Dashboard Admin',
    shopeePromo: 'Powerbiz - Shopee Promo',
    addProductMaster: 'Powerbiz - Add Product Master',
    editProductMaster: 'Powerbiz - Edit Product Master',
    importProductMaster: 'Powerbiz - Import Product Master',
    stockAllocation: 'Powerbiz - Stock Allocation',
    bulkPublishProduct: 'Powerbiz - Bulk Publish Product Channel',
    addProductTokopedia: 'Powerbiz - Add Product Tokopedia',
    addProductChannel: 'Powerbiz - Add Product Channel',
    editProductChannel: 'Powerbiz - Edit Product Channel',
    priceSetting: 'Powerbiz - Price Setting',
    withdrawal: 'Powerbiz - Withdrawal',
    walletHistory: 'Powerbiz - Wallet History',
    walletWithdrawal: 'Powerbiz - Wallet Withdrawal',
    payment: 'Powerbiz - Payment',
    paymentHistory: 'Powerbiz - Payment History',
    invoice: 'Powerbiz - Invoice',
    creditNotes: 'Powerbiz - Credit Notes',
    productDiscount: 'Powerbiz - Product Discount',
    addDiscount: 'Powerbiz - Add Discount',
    voucher: 'Powerbiz - Voucher',
    addVoucher: 'Powerbiz - Add Voucher',
    approval: 'Powerbiz - Approval',
    customer: 'Powerbiz - Customer',
    formCustomer: 'Powerbiz - Form Customer',
    storeList: 'Powerbiz - Store List',
    addStore: 'Powerbiz - Add Store',
    confirmStore: 'Powerbiz - Confirm Store',
    integration: 'Powerbiz - Integration',
    integrationListChannel: 'Powerbiz - Integration List Channel',
    purchaseOrder: 'Powerbiz - Purchase Order',
    createPurchaseOrder: 'Powerbiz - Create Purchase Order',
    supplier: 'Powerbiz - Supplier',
    error404: 'Powerbiz - Error 404',
    error403: 'Powerbiz - Error 403',
    error500: 'Powerbiz - Error 500',
    linkExpired: 'Powerbiz - Link Expired',
    signIn: 'Powerbiz - Sign In',
    forgotPassword: 'Powerbiz - Forgot Password',
    resetPassword: 'Powerbiz - Reset Password',
    register: 'Powerbiz - Register',
    registerConfirmation: 'Powerbiz - Register Confirmation',
    registrationSuccess: 'Powerbiz - Registration Success',
    userConfirmInvitation: 'Powerbiz - User Confirm Invitation',
    ownerConfirmInvitation: 'Powerbiz - Owner Confirm Invitation',
    userNotFound: 'Powerbiz - User Not Found',
    timeout: 'Powerbiz - Timeout',
    fullViewLabel: 'Powerbiz - Full View Label',
    redeemProduct: 'Powerbiz - Redeem Product',
    addProductRedeem: 'Powerbiz - Add Product Redeem',
    editProductRedeem: 'Powerbiz - Edit Product Redeem',
    redeemSales: 'Powerbiz - Redeem Sales',
    distributor: 'Powerbiz - Distributor',
    addDistributor: 'Powerbiz - Add Distributor',
    submission: 'Powerbiz - Submission',
    retur: 'Powerbiz - Retur',
    banner: 'Powerbiz - Banner',
    cmsRedirectionTitle: 'Redirected Successfully',
    cmsRedirectionSubTitle: 'The CMS Management page has been opened in a new tab. If it does not appear, please click the button below.',
    cmsRedirectionSubTitleRedirecting: 'You will be redirected to the third-party CMS Management page.',
    cmsRedirectionButton: 'Open CMS Management',
    name: 'Name',
  },
  topBar: {
    profileMenu: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      logout: 'Logout',
      account_setting: 'Account Setting',
      switch_to: 'Switch to',
    },
    subscribeNow: 'Subscribe Now',
    no_Business: 'Business not found!',
    no_Warehouse: 'Warehouse not found!',
    search_Business: 'Search business',
    search_Warehouse: 'Search warehouse',
    further_data: 'Search for further data.',
    total_Business: '{value} business',
    total_Warehouse: '{value} warehouse',
    all_: 'All',
    all_Business: 'All Business',
    all_Warehouse: 'All Warehouse',
    all_Channel: 'All Channel',
    all_SalesChannel: 'All Sales Channel',
    refresh: 'Refresh',
  },

  snackBar: {
    notYetConnected: 'Your account not yet connect with your store.',
    storeConnected: 'Your account connected with',
    store: 'Store',
    ConnectToYourStore: 'Connect to Store',
  },

  auth: {
    login: 'Sign In',
    register: 'Register',
    notRegister: 'Dont have an account yet?',
    signupNow: 'Sign Up Now!',
    empowering_title1: 'Empowering',
    empowering_title2: 'Your Brand',
    empowering_desc: 'We offer an end-to-end solution and services to empower your brand, transform your business, and bring your products to global market with Omni-Channel Technology Platform',
    schedule_demo: 'Schedule a demo',
    view_our: 'View our',
    terms: 'Terms',
    and: 'and',
    privacy_policy: 'Privacy Policy',
    emailPhoneLabel: 'Email or Phone Number',
    emailAndPhoneBlank: 'email or phone is required',
    password: 'Password',
    invalidPassword: 'Invalid Password',
    confirmPassword: 'Password Confirmation',
    forgetPassword: 'Forgot Password',
    resetPass: 'Reset Password',
    requiredEmail: 'Email Required',
    goToSignIn: 'Go to Sign In page',
    name: 'Name',
    businessName: 'Business Name',
    anotherRegister: 'Try another way to Sign Up',
    anotherSign: 'Try another way to Sign In',
    passwordNotMatch: 'Confirm Password Not Match',
    requiredName: 'Name cannot be empty',
    minimumLengthPassword: 'Minimum password length 6 characters',
    atLeastOneUppercase: 'Password at least have 1 uppercase character',
    atLeastOneNumber: 'Password at least have 1 number',
    atLeastOneSpecialChar: 'Password at least have 1 special character',
    verifyAccount: 'Please verify your registration',
    sendOtpTo: 'We have sent OTP Code to',
    resendOtp: 'Resend OTP',
    successVerification: 'Verification Success',
    userNotRegistered: 'User Not Registered',
    goToDashboard: 'Go To Dashboard',
    goToLogin: 'Go To Login',
    needVerification: 'Please verify',
    changeEmail: 'Change Email',
    emailAddress: 'Email Address',
    emailExpired: 'Oops, there is a problem with your link',
    expiredDescription:
      'Looks like your link has expired or not copied correctly. Please check and try again or ask your friend to resend the invitation.',
    resendEmail: 'Resend email',
    resetMyPass: 'Reset My Password',
    sendAgain: 'Send again',
    invalidEmailPhoneNumber: 'Invalid phone number or email',
    successRegister: 'Registration Success',
    loginFailed: 'Login Failed',
    hasAccount: 'Already have an account?',
    loginHere: 'Sign In',
    signUpWithGoogle: 'Sign Up With Google',
    signUpWithFacebook: 'Sign Up With Facebook',
    signInWithGoogle: 'Sign In with Google',
    signInWithFacebook: 'Sign In with Facebook',
    loading: 'Loading',
    internalServerError: 'Internal Server Error',
    changePassword: 'Change Password',
    backToLogin: 'Back to Login',
    username: 'Username',
    phoneNumber: 'Phone Number',
    emailInvalid: 'Email is not valid',
    fieldRequired: '{0} is required',
    newPassword: 'New Password',
    updatePassword: 'Update Password',
    resendCodeIn: 'Resend code in',
    validate: 'Validate',
    confirmationInvitation: 'Confirmation Invitation',
    hasAccountTrue: 'Already have an account',
    hasAccountFalse: 'Don\'t have an account',
    fullName: 'Full Name',
    pleaseLogoutFirst: 'Please Logout First!',
    clickLinkAgain: 'Then Click The Link On Email Again To Confirm.',
    creatingWorkspace: 'Creating Your Workspace',
    pleaseWait: 'Please Wait . . .',
    changePhoneNumber: 'Change Phone Number',
    passwordChangedSuccess: 'Your Password has been successfully changed',
    loginToPowerBiz: 'Login to PowerBiz',
  },
  fulfillment: {
    sent: 'Sent',
    picked: 'Picked',
    packed: 'Packed',
    shipped: 'Shipped',
    readyToShip: 'Ready to Ship',
    printLabel: 'Print Label',
    print_label: 'Print Label',
    shippingId: 'Shipping ID',
    allWarehouses: 'All Warehouses',
    closeDetail: 'Close Detail',
    viewDetail: 'View Detail',
    changeAwb: 'Change AWB',
    inputAwb: 'Input AWB',
    enterAwb: 'Enter AWB',
    reviseDeliveryOrder: 'Revise Delivery Order',
    orderNo: 'Order No',
    awbSaveFailed: 'Oops, Failed to Save AWB',
    accept: 'Accept',
    cancel: 'Cancel',
    allChannels: 'All Channels',
    allShippingTypes: 'All Shipping Types',
    startDate: 'Start Date',
    endDate: 'End Date',
    checkStock: 'Check Stock',
    otherProducts: '+ {count} other products',
    showLess: 'Show Less',
    shipping: 'Shipping',
    buyerAccepted: 'Buyer has confirmed order receipt',
    buyerNotAccepted: 'Buyer has not confirmed order receipt yet',
    printOrderLabel: 'Print Order Label',
    printLabelDesc: 'Print shipping address with item details?',
    yesWithDetails: 'Yes, with item details',
    noAddressOnly: 'No, only address',
    noSku: 'SKU Number',
    inDelivery: 'In Delivery',
    confirm: 'Confirm',
    selectDateClosed: 'Select Shop Closed Date',
    updateStockInfo: 'Update Product Stock Information',
    reason: {
      productOutOfStock: 'Product Out of Stock',
      variantUnavailable: 'Product Variant Unavailable',
      wrongPriceOrWeight: 'Wrong Price or Weight',
      shopClosed: 'Shop Closed',
      others: 'Others',
      courierIssue: 'Courier Issue',
      buyerRequest: 'Buyer Request',
    },
    cancelDetailsMinLength: 'Cancellation details minimum 30 characters',
    enterDateClosed: 'Enter Shop Closed Date',
    successCancelOrder: 'Success cancel order',
    min_char: 'min characters',
    send: 'Send',
    reject_order: 'Reject Order',
    reason_cancel: 'Reason for Cancellation',
    cancel_order: 'Cancel Order',
    separateShipment: 'Separate Shipment',
    cancelItem: 'Cancel Item',
    changeItem: 'Change Item',
    submitToWms: 'Submit to WMS',
    status: 'Status',
    search: 'Search',
    totalFulfillment: 'Total Delivery Order {value}',
    order_date: 'Order Date',
    order_id: 'Order ID',
    business: 'Business',
    channel: 'Channel',
    warehouse: 'Warehouse',
    totalItem: 'Total Item',
    all: 'All',
    new: 'New',
    do_process: 'Process',
    picking: 'Picking',
    packing: 'Packing',
    ready_to_ship: 'Ready to Ship',
    in_delivery: 'In Delivery',
    delivered: 'Delivered',
    canceled: 'Canceled',
    check_do_data: 'Check DO Data',
    booked: 'Booked',
    pending: 'Pending',
    oos: 'OOS',
    sla: 'SLA',
    booking_status: 'Booking Status',
    created_date: 'Created Date',
    store: 'Store',
    bulk_accepted: 'Bulk Accepted',
    bulk_picking: 'Bulk Picking',
    bulk_packing: 'Bulk Packing',
    bulk_good_issued: 'Bulk Good Issued',
    bulk_shipped: 'Bulk Shipped',
    bulk_delivered: 'Bulk Delivered',
    print_picking_list: 'Print Picking List',
    print_shipping_label: 'Print Shipping Label',
    cancel_bulk_actions: 'Cancel Bulk Actions',
    separate_shipment: 'Separate Shipment',
    return_requested: 'Return Requested',
    returned: 'Returned',
    cancel_requested: 'Cancel Requested',
    select_order_to_be: 'Select order to be {action}',
    bulk_accepted_msg: 'accepted',
    bulk_picking_msg: 'picking',
    bulk_packing_msg: 'packing',
    bulk_good_issued_msg: 'good issued',
    bulk_shipped_msg: 'shipped',
    bulk_delivered_msg: 'delivered',
    processed: 'processed',
    submit_to_wms_msg: 'submitted to WMS',
    bulk_actions_no_eligible: 'No orders are eligible for bulk actions process',
    printed_msg: 'printed',
    bulk_title: 'Bulk {action}',
    created: 'New',
    process: 'Process',
    cancelRequested: 'Cancellation Request',
    canceled: 'Canceled',
    submitSuccess: 'Submit Success',
    submitSuccessDesc: 'If fulfillment data has not changed, please wait a moment and refresh fulfillment data',
    submitFailed: 'Submit Failed',
    submitFailedDesc: 'Please contact Admin regarding Submit to WMS issues',
    stockAmount: 'Stock Amount',
    done: 'Done',
    reload: 'Reload',
    save: 'Save',
    back: 'Back',
    addProduct: 'Add Product',
    searchItem: 'Search Item',
    changeQty: 'Change Qty',
    addItem: 'Add Item',
    logistic: 'Logistic',
    separatedQty: 'Separated Qty',
    sender: 'Sender',
    recipient: 'Recipient',
    orderDate: 'Order Date',
    shippingCost: 'Shipping Cost',
    insuranceCost: 'Insurance Cost',
    note: 'Note',
    product: 'Product',
    quantity: 'Quantity',
    printWithShippingId: 'Print with Shipping ID',
    confirmChange: 'Are you sure you want to make this change?',
    confirmCancelItemOrder: 'Canceling this item will cause the order to be canceled, Are you sure you want to cancel the following item?',
    confirmCancelOrder: 'Are you sure you want to cancel the following order?',
    confirmChangeQty: 'Are you sure you want to change the quantity of the following order item?',
    initial_shipment: 'Initial Shipment',
    product_canceled: 'Canceled Product',
    yesCancelItem: 'Yes, Cancel Item',
    yesChangeQty: 'Yes, Change Quantity',
    successUpdateOrder: 'Success update order',
    noAccess: 'You do not have access to this feature',
    inventoryBooking: 'Inventory Booking',
    next: 'Next',
    historyList: 'History List',
    filter: 'Filter',
    failed: 'Failed',
    tryAgain: 'Try Again',
    completed: 'Completed',
    shipping_id: 'Shipping ID',
    warehouse: 'Warehouse',
    inventory_status: 'Inventory status',
    didntHaveData: 'Belum Memiliki Data',
    didntHaveDataCaption: 'Saat ini anda \n belum memiliki data',
    exportExcelFile: 'Export Excel File',
    exportHistoryPage: 'Export History Page',
    captionNotifFilterBeforeExport: 'Lakukan Filter sebelum melakukan export \n dengan jangka waktu maksimal 3 bulan',
    created_date: 'Created Date',
    service_type: 'Priority',
    store: 'Nama Toko',
    inventory: 'Inventory',
    notification_success_accept_order: 'Success accept order',
    notification_success_update_order: 'Success update order',
    changeOrder: 'Ubah Pesanan',
    itemProduct: 'Item Produk',
    splitShipment: 'Split Shipment',
    backToChangeOrder: 'Kembali Ubah Pesanan',
    booking_inventory: 'Booking Inventory',
    sla: 'SLA',
    bulk_accepted: 'Bulk Accepted',
    bulk_picking: 'Bulk Picking',
    bulk_packing: 'Bulk Packing',
    bulk_good_issued: 'Bulk Good Issued',
    bulk_shipped: 'Bulk Shipped',
    bulk_delivered: 'Bulk Delivered',
    print_picking_list: 'Print Picking List',
    print_shipping_label: 'Print Shipping Label',
    cancel_bulk_actions: 'Cancel Bulk Actions',
    accept_msg: 'Are you sure to accept this order?',
    reject_msg: 'Are you sure to reject this order?',
    pick_confirmed_msg: 'Apakah Anda yakin akan mengambil pesanan berikut?',
    pack_confirmed_msg: 'Apakah Anda yakin akan mengemas pesanan berikut?',
    packing_completed_msg: 'Apakah Anda yakin akan mengirimkan pesanan berikut?',
    good_issued_msg: 'Apakah Anda yakin pesanan sudah siap dikirim?',
    shipped_msg: 'Apakah Anda yakin pesanan sudah terkirim?',
    accept_order: 'Yes, Accept Order',
    reject_order: 'Yes, Reject Order',
    btn_caption_accept_pick_confirmed: 'Ya, ambil pesanan',
    btn_caption_accept_pack_confirmed: 'Ya, kemas pesanan',
    btn_caption_packing_completed: 'Ya, kirimkan pesanan',
    btn_caption_good_issued: 'Ya, Pesanan siap dikirim',
    btn_caption_shipped: 'Ya, Pesanan terkirim',
    accept_cancel_order: 'Accept Cancel Order',
    description: 'Description',
    order_list: 'Order List',
    setting_label: 'Shipping Label Settings',
    sub_total_order: 'Sub Total Order',
    paper_size: 'Paper Size',
    print_details: 'Print with item details',
    print_all_details: 'Print all with item details',
    print_unboxing_video_label: 'Print with mandatory unboxing video label',
    print_all_unboxing_video_label: 'Print all with mandatory unboxing video label',
    print_barcode_awb: 'Print with AWB barcode',
    print_all_barcode_awb: 'Print all with AWB barcode',
    print_barcode_no_order: 'Print with order number barcode',
    print_all_barcode_no_order: 'Print all with order number barcode',
    packing_completed: 'Dikirim',
    export_modal: {
      title: 'Export Data',
      do_status: 'Delivery Order Status',
      select_do_status: 'Select Delivery Order Status',
      inventory_status: 'Inventory Status',
      select_inventory_status: 'Select Inventory Status',
      warehouse: 'Warehouse',
      select_warehouse: 'Select Warehouse',
      channel: 'Channel',
      select_channel: 'Select Channel',
      shipping_type: 'Priority',
      select_shipping_type: 'Select Priority',
      order_date: 'Order Date',
      start_date: 'Start Date',
      end_date: 'End Date',
      close: 'Close',
      export_data: 'Export Data',
      all: 'All',
      booked: 'Booked',
      pending: 'Pending',
      oos: 'OOS',
    },
    detailDeliveryOrder: 'Detail Delivery Order',
    detailItemProduct: 'Detail Item Product',
    skuNotFoundWarehouse: 'SKU is not in the selected warehouse, please add the warehouse first for that SKU',
    skuRequired: 'SKU must be selected',
    qtyRequired: 'Qty must be filled',
    qtyCannotBeZero: 'Qty cannot be 0',
    confirmDeleteItem: 'Are you sure you want to delete SKU: {sku} ?',
    cannotDeleteLastItem: 'Cannot delete the last item',
    detailItemProductEmpty: 'Product Item Detail cannot be empty',
    skuNotInSelectedWarehouse: 'SKU {skus} is not in the selected warehouse',
    revisionSavedSuccess: 'Revision Data Successfully Saved',
    revisionSavedFailed: 'Revision Data Failed to Save',
    searchSku: 'Search SKU',
    stock: 'Stock',
    noData: 'No Data',
    printSlip: 'Print Slip',
    selectReferenceItem: 'Select Reference Item',
    selectReferenceItemDesc: 'Select the original order item to be used as reference for the new item.',
    referenceItem: 'Reference',
    hasZeroStockItem: 'There are items with zero stock',
    confirmRevisionDoTitle: 'Confirm Delivery Order Revision',
    confirmRevisionDoDesc: 'System detected products with ',
    zeroStockStatus: 'zero stock (0)',
    confirmRevisionDoQuestion: 'Are you sure you want to continue this revision?',
    continueRevision: 'Continue Revision',
    update_package: 'Update Package',
    update_package_success: 'Update Package success',
    update_package_failed: 'Update Package failed',
    priority_level: 'Priority',
  },
  authForm: {
    systemBusy: 'System seems to be busy, please try again later or contact administrator!',
  },
  notification: {
    successAddDiscount: 'Add Discount Voucher Success',
    successDeleteVoucher: 'Delete Voucher Success',
    duplicateVoucherCode: 'Voucher code already exist',
    failedSearchSalesOrder: 'Please select parameter for search sales order',
    failedSearchVoucher: 'Please select parameter for search voucher',
  },
  sideBar: {
    dashboard: 'Dashboard',
    sales: 'Sales',
    fulfillment: 'Fulfillment',
    product: 'Product',
    product_master: 'Master Product',
    productCategory: 'Kategori Produk',
    management_category: 'Category Management',
    price_setting: 'Price Setting',
    global_variable: 'Global Variable',
    formula_variable: 'Formula Variable',
    product_variable: 'Product Variable',
    price_formula: 'Price Formula',
    inventory: 'Inventory',
    stock: 'Inventory',
    stock_alocation: 'Stock Alocation',
    inventory_list: 'Stock Availability',
    inventory_movement: 'Inventory Movement',
    setup_stock: 'Stock Setup',
    transfer_stock: 'Stock Transfer',
    promotion: 'Promotion',
    customer: 'Customer',
    channel: 'Channel',
    analytic: 'Analytic',
    finance: 'Finance',
    user: 'User',
    account: 'Account',
    user_management: 'User Management',
    setting: 'Setting',
    integration: 'Integration',
    business: 'Business',
    warehouse: 'Warehouse',
    shipping: 'Shipping',
    customer_setting: 'Customer',
    sales_setting: 'Sales Setting',
    account_setting: 'Account Setting',
    distributorship: 'Distributorship',
    sales_order: 'Sales Order',
    product_list: 'Product',
    distributorship_management: 'Distributor Manage..',
    store_management: 'Store Management',
    store_setting: 'Store Setting',
    price_group_setting: 'Price-Group Setting',
    export_history: 'Export History',
    price: 'Price Setting',
    add_store: 'Add Store',
    add_warehouse: 'Add Warehouse',
    type_shop_name: 'Type shop name',
    type_warehouse_name: 'Type Warehouse Name',
    no_shop: 'No shop list yet!',
    reseller: 'Reseller',
    resellerdetail: 'Detail Reseller',
    voucher: 'Voucher',
    voucherdetail: 'Detail Voucher',
    addvoucher: 'Add Voucher',
    editvoucher: 'Edit Voucher',
    storesetting: 'Store Settings',
    adjustment: 'Stock Adjustment',
    'goods-receipt': 'Goods Receipt',
    'return-received': 'Return Received',
    'inventory movement': 'Inventory Movement',
    promo_channel_list: 'Manage Discount Promo',

    distributor: 'Distributor',
    distributor_list: 'Distributor List',
    customer_category: 'Customer Category',
    discount: 'Discount',
    approval: 'Approval',
    withdrawal: 'Withdrawal',
    payment_channel: 'Payment Channel',
    payment_history: 'Payment History',
    invoice: 'Invoice',
    retur: 'Retur',
    'retur-request-list': 'Retur Request List',
    'retur-list': 'Retur List',
    web_management: 'Web Management',
    banner: 'Banner',
    redeem: 'Loyalty',
    redeem_sales_channel: 'Redeem',
    redeem_product_channel: 'Product',
    liststore: 'Store List',
    product_collection: 'Product Collection',

    'credit-notes': 'Credit Notes',
    'customer-list': 'Customer List',
    'price-area': 'Price Area',
    'product-list': 'Product List',
    do: 'Delivery Order',
    po_and_supplier: 'Purchase Order',
    purchase_order: 'Inbound Delivery',
    supplier: 'Manage Supplier',
    'setup-product-tags': 'Setup Product Tags',
    'manage-product-tags': 'Manage Product Tags',
  },
  settingsStore: {
    logo: 'Logo',
    banner: 'Home Banner',
    categoryBanner: 'Category Banner',
    resellerBanner: 'Reseller Banner',
    uploadImage: 'Upload Image',
    title: 'Store Settings',
    delete_confirm: 'Are you sure want to delete this item?',
    image_type: 'Image Type',
    select_image_type: 'Select Image Type',
    choose_image: 'Choose image',
    upload: 'Upload',
    dimension_uploaded: 'The dimensions of the photo you uploaded are: {value}',
    dimension_recomended: 'the recommended dimensions for {name} are: {value}',
    redirect_url: 'Redirect URL',
    optional: 'optional',
    error_max_banner: 'The maximum number of banners that can be uploaded is 10',
    failed: 'Failed',
  },
  dashboardContent: {
    detail_link: 'Detail',
    total_sku: 'Total SKU',
    order: 'Order',
    orderStatus: 'Order Status',
    orderStatusDescription:
      'Summary of current order status that needs to be followed up',
    orderStatusNew: 'New',
    orderStatusConfirmed: 'Confirmed',
    orderStatusSent: 'Sent',
    orderStatusSuccess: 'Success',
    orderStatusCancel: 'Canceled',
    summaryItemInventory: 'Item Inventory',
    summaryBusiness: 'Business',
    summaryClient: 'Client',
    summaryPO: 'Pending Order',
    summaryItemNoStock: 'Out of Stock',
    summarySalesToday: 'Sales Today',
    summaryLogisticToday: 'Logistics Expenditure Today',
    summaryItemSoldToday: 'Item Sold Today',
    summarySales: 'Sales',
    summaryLogistic: 'Logistics Expenditure',
    summaryItemSold: 'Item Sold',
    paramToday: 'Today',
    paramLast7day: 'Last 7 Day',
    paramLast30day: 'Last 30 Day',
    paramThisMonth: 'This Month',
    paramLastYear: 'Last 1 Year',
    paramThisYear: 'This Year',
    salesOverview: 'Sales Overview',
    section_description_inventory: 'Total Items in Inventory',
    section_description_business: 'Total Items in Business',
    section_description_client: 'Total Partnered Clients',
    section_description_PO: 'Total Items in Pending Order',
    section_description_nostock: 'Total Items Out of Stock',
    section_description_salesToday: 'Total Items in Sales Today',
    section_description_logisticToday: 'Total Logistics Expenditure Today',
    section_description_itemsoldToday: 'Total Items Sold Today',
    section_description_sales: 'Total Items in Sales',
    section_description_logistic: 'Total Logistics Expenditure',
    section_description_itemsold: 'Total Items Sold',
    top_region: 'Top 10 Region',
    top_region_description: 'Top 10 Region with the Most Sales',
    shipping: 'Shipping',
    shipping_description: 'Top 10 Courier Delivery',
    channel: 'Channel',
    sales_channel: 'Sales Channel',
    info_channel: 'List of top 10 channels',
    info_sales_channel: 'List of top 10 sales channels',
    info_business: 'List of top 10 businesses',
    info_warehouse: 'List of top 10 warehouses',
    info_courier: 'List of top 10 couriers',
    info_payment_method: 'List of top 10 payment methods',
    channel_description: 'Channel Summary',
    business: 'Business',
    business_description: 'Business Summary',
    warehouse: 'Warehouse',
    courier: 'Logistic',
    payment: 'Payment',
    payment_method: 'Payment Method',
    payment_description: 'Payment Summary',
    no_data: 'No data',
    start_date: 'Start Date',
    end_date: 'End Date',
    today: 'Today',
    is_today: 'today',
    not_today: '',
    today_month: 'This Month',
    today_year: 'This Year',
    last_week: 'Last 7 Days',
    last_month: 'Last 30 Days',
    last_year: 'Last 1 Year',
    transaction_status: 'Transaction Status',
    detail_status: 'Summary of delivery order transaction status to date that needs to be followed up',
    today_summary: 'Today Summary',
    sales: 'Sales',
    logistic: 'Logistic',
    logistic_expenses: 'Logistic Expenses',
    item_sold: 'Item Sold',
    report: 'Report',
    date_difference: 'End date min. 7 days from start date',
    sales_overview_graph: 'Sales Overview Graph',
    compare: 'Compare',
    detail_channel: 'List of top 10 channels based on transactions',
    province: 'Province',
    detail_province: 'List of top 10 provinces based on number of orders',
    city: 'City / Regency',
    detail_city: 'List of top 10 cities/regencies based on number of orders',
    product: 'Best Selling Product',
    detail_product: 'List of top 10 products based on qty',
    catalog: 'Best Selling Item',
    detail_catalog: 'List of top 10 items based on qty',
    shopee_id: 'Shopee',
    tokopedia_id: 'Tokopedia',
    tiktok: 'Tiktok',
    tiktok_id: 'Tiktok',
    blibli_id: 'Blibli',
    lazada_id: 'Lazada',
    toco_id: 'Toco',
    distributor: 'Distributorship',
    store: 'Webcommerce',
    total: {
      sku: 'Total item in the warehouse',
      oos: 'Total empty item in the warehouse',
      sales: 'Total',
      canceled_sales: 'Total canceled',
      logistic_expenses: 'Total shipping cost',
      item_sold: 'Total item sold',
    },
  },
  sales: {
    sync_order: 'Sync Order',
    resend_sfa: 'Resend SFA',
    detail_sfa: 'Detail SFA',
    awb_status: 'AWB Delivery Status',
    delivery_data_not_found: 'Delivery Data Not Found',
    delivery_data_not_found_msg: 'Please try again later or contact Admin regarding delivery data issues',
    channel: 'Channel',
    seller: 'Seller',
    status: 'Status',
    delivery_status: 'Delivery Status',
    shipping_status: 'Shipping Status',
    waiting: 'Waiting',
    picking: 'Picking',
    packing: 'Packing',
    ready_to_ship: 'Ready to Ship',
    on_delivery: 'On Delivery',
    delivered: 'Delivered',
    completed: 'Completed',
    track: 'Track',
    canceled_by_buyer: 'Canceled by buyer',
    canceled_by_seller: 'Canceled by seller',
    system_cancellation: 'System cancellation',
    no_history_data: 'No history data',
    date_from: 'Periode',
    business_id_sales: 'Business',
    sales_channel_id: 'Channel',
    warehouse_id: 'Warehouse',
    customer_name: 'Customer Name',
    courier_name: 'Courier Name',
    unmapped_products_warning: 'This order contains unmapped products',
    instant_courier_info: 'This order uses instant courier',
    order_type: 'Order Type',
    fulfillment_priority_level: 'Priority',
  },
  manualOrder: {
    create_title: 'Form Create Manual Order',
    transaction_detail: 'Transaction Detail Data',
    buyer_data: 'Buyer Data',
    cart_title: 'Transaction Cart',
    shipping_data: 'Shipping Data',
    billing_data: 'Billing Data',
    transaction_summary: 'Transaction Summary',
    order_number: 'Order Number',
    input_order_number: 'Input order number',
    warehouse: 'Warehouse',
    date: 'Date',
    input_date: 'Input order date',
    payment_method: 'Payment Method',
    payment_status_placeholder: 'Paid / Unpaid',
    first_name: 'First Name',
    last_name: 'Last Name',
    attachment_url: 'Attachment URL',
    input_first_name: 'Input first name',
    input_last_name: 'Input last name',
    input_email: 'Input email',
    input_phone: 'Input phone number',
    input_attachment_url: 'Input attachment url',
    add_item: 'Add Item',
    bulk_item_import: 'Bulk Item Import',
    no_product_in_warehouse: 'No products registered in the selected warehouse',
    product_placeholder: 'Product',
    stock_unavailable: 'Stock unavailable',
    all_products_loaded: 'All products loaded',
    msrp: 'MSRP',
    sub_total: 'Sub Total',
    sub_total_cart: 'Cart Sub Total',
    shipping_type: 'Select Shipping Type',
    courier: 'Courier',
    self_pickup: 'Self Pickup',
    courier_type: 'Select Courier Type',
    custom_courier: 'Custom Courier',
    integrated_courier: 'System Integrated Courier',
    integrated_courier_tooltip: 'AWB number, shipping cost, and insurance cost are automatically filled by the system.',
    custom_courier_tooltip: 'You can fill in the AWB number, shipping cost, and shipping insurance cost freely (custom).',
    courier_service: 'Courier Service',
    choose_courier: 'Choose Courier',
    choose_service: 'Choose service',
    awb_number: 'Air Way Bill No.',
    input_awb: 'Input air way bill number',
    courier_not_available: 'Sorry, courier is not available for the selected shipping address',
    street_name: 'Street Name',
    use_shipping_address: 'Use shipping address for billing address',
    discount: 'Discount',
    shipping_cost: 'Shipping Cost',
    insurance_cost: 'Insurance Cost',
    grand_total: 'GRAND TOTAL',
    create_single_order: 'Create Single Order',
    create_bulk_order: 'Create Bulk Order',
    import_export: 'Export / Import',
    import_manual_order: 'Import Manual Order',
    verify_file: 'Verify File',
    upload_file: 'Upload File',
    upload_bulk_manual_order: 'Upload Bulk Manual Order',
    verify_failed: 'Verification Failed',
    verify_success: 'Verification Success',
    empty_data: 'Empty Data',
    empty_data_msg: 'Please fill in at least 1 row of data to process Bulk Order.',
    verified_msg: 'All data has passed verification.',
    verified_action_msg: 'Please click the <b>Upload File</b> button to process the Bulk Order.',
    failed_lines_msg: 'There are <b>{count}</b> rows of data that failed verification.',
    fix_data_msg: 'Please fix the data to process the Bulk Order.',
    check_remark_msg: 'NB: Check the <b>Remark</b> column (last column)',
    download_failed_data: 'Download Failed Data',
    upload_attachment: 'Upload Attachment',
    gen_own_label: 'Gen Own Label',
    url: 'URL',
    input_label_url: 'Input label url',
    invalid_url_alert: 'The URL you entered is <b>invalid</b>, you can <b>leave it blank</b> if you don\'t have a shipping label URL',
    valid_url_example: 'Valid URL Example:',
    please_choose_city: 'Please Choose City',
    shipping_warehouse_warning: 'Please fill in the shipping address & warehouse first before filling in the courier form',
    warehouse_product_warning: 'Please select a warehouse before adding products',
    weight_change_calculating: 'There is a change in the total product weight, recalculating shipping costs.',
    max_char_warning: 'Maximum {max} characters',
    select_payment_method: 'Select payment method',
    select_order_date: 'Select order date',
    select_country: 'Select country',
    select_city: 'Select city',
    select_district: 'Select district',
    input_postcode: 'Input postal code',
    input_address: 'Input address',
    select_warehouse: 'Select warehouse',
    select_courier: 'Select courier',
    select_courier_service: 'Select courier service',
    fail_create_order: 'Failed to create order',
    input_valid_url: 'Please enter a valid shipping label URL',
    add_item_min_1: 'Please add at least 1 item',
    item_not_filled: 'There are items that have not been filled in',
    some_data_invalid: 'Some data is invalid',
    all_data_imported: 'All Data Successfully Imported',
    error_get_store_id: 'Failed to get store id',
    error_occurred: 'An error occurred',
    success_update_shipping_cost: 'Successfully updated shipping cost',
    error_calculating_shipping_cost: 'An error occurred while calculating shipping costs',
    check_qty_warning: 'Please check the product quantity again, quantity cannot be 0',
    check_uom_warning: 'Please check the product UOM again, UOM cannot be empty',
    success_create_order: 'Successfully created order',
    order_number_label: 'order number',
    max_item_warning: 'The number of items exceeds the maximum limit, the maximum limit is {max} items',
    error_add_item: 'Failed to add item',
    import_items: 'Import Items',
    selling_price: 'Selling Price',
    product_discount: 'Product Discount',
    qty: 'Qty',
    total: 'Total',
    upload_excel_msg: 'Upload your excel file here',
    manage_edit_product: 'Manage / Edit Products',
    add_product: 'Add Product',
    cancel_confirm_title: 'Cancel Order Creation?',
    cancel_confirm_content: 'All entered data has not been saved and will be lost.',
    yes_cancel: 'Yes, Cancel',
    back: 'Back',
    delete_cart_confirm: 'Remove this product from cart?',
    no_product_in_cart: 'No products in cart yet',
    product_in_cart: 'Products in cart',
    view_detail_table: 'View Table Detail',
    show_list: 'Show List',
    hide_list: 'Hide List',
    product_summary: 'Product Summary',
    done: 'Done',
    template_hint: 'If you don\'t have an import items file template yet, please click the download file button at the bottom left.',
    download_template: 'Download Template',
    submit_all_items: 'Submit All Items',
    uploading_file: 'Uploading file...',
    success_item: 'Successful items:',
    failed_item: 'Failed items:',
  },
  add_store: {
    channel_integration: 'Integrasi Saluran',
    mandatory_selected_warehouse:
      'Make sure you have selected a warehouse, then select a channel to integrate into your store',
    marketplace_integration: 'Marketplace Integration',
    fulfillment_integration: 'Fulfillment Integration',
    coming_soon: 'Coming soon',
    sync_tips: 'Sync Tips',
    note_tips:
      'When it starts syncing you will be redirected to the {name} page for login and authorization. After successful authorization you can arrange delivery service in Powerbiz Delivery Service Settings.',
    loading_integration: 'Integration in progress, please wait.',
    integration_failed_title: 'Integration Cannot Be Performed.',
    integration_failed_warehouse: 'Please input your Warehouse Data first',
    input_warehouse_btn: 'Input Warehouse Data',
    shopee_integration_failed: 'Shopee Integration Failed',
    tiktok_integration_failed: 'Tiktok Integration Failed',
    lazada_integration_failed: 'Lazada Integration Failed',
    toco_integration_failed: 'Toco Integration Failed',
    errors: {
      select_business_first: 'Please select a business first, before integrating the store',
      failed: 'Failed',
      redirect_failed: 'Redirect Failed',
      connected_failed: 'Connected Failed',
      blibli_integration_failed: 'Blibli Integration Failed',
      store_required: 'Store must be selected',
      warehouse_required: 'Warehouse must be selected',
      shop_already_exist_business_id: 'This shop is already registered with a different Business ID.',
      invalid_auth_code: 'The authorization code is expired or invalid. Please try connecting your shop again.',
      marketplace: 'Marketplace',
      warehouse: 'Warehouse',
    },
    blibli_sync: {
      how_to_get_title: 'How do you get your Store Name, ID & Password?',
      step_1: 'Step 1',
      step_1_desc_1: 'Copy the following Powerbiz Client ID API:',
      step_1_desc_2: 'Log in to your Blibli Seller Center',
      step_1_desc_3: 'Click the Seller API Manager menu in your store profile section',
      step_1_desc_4: 'At the bottom there is a <b>Bind API Client</b> section',
      step_1_desc_5: 'Copy the <b>API Client ID</b> Code in the available column',
      step_1_desc_6: 'Then click the <b>BIND</b> button then click the <b>YES</b> button if requested',
      step_2: 'Step 2',
      step_2_desc_1: 'In the <b>Manage API Key</b> section click the <b>Generate</b> button',
      step_2_desc_2: 'Record the <b>API Seller Key</b> value that appears and your <b>Store Code</b>',
      step_2_desc_3: 'Copy in the column provided in this form',
      step_2_desc_4: 'Next step click the <b>Start Sync</b> button',
      step_2_desc_5: 'Finally you are asked to select your Powerbiz Warehouse and channel to connect',
      step_2_desc_6: 'If so, your store integration process is complete',
      note: 'Note: Please turn off the signature key / API password setting to <b>off</b> position',
      video_tutorial: 'Click the following link to see the video tutorial',
      sync_warehouse: 'Sync Warehouse',
      channel_warehouse_list: 'Channel Warehouse List',
      powerbiz_warehouse_list: 'Powerbiz Warehouse List',
      warehouse_required: 'Powerbiz Warehouse must be selected',
      select_main_warehouse: 'Select Main Warehouse',
      authorization_success_title: 'Warehouse Authorization Successful!',
      authorization_success_desc: 'Successfully added Main Warehouse and Channel Warehouse.',
      ok: 'OK',
      integration_failed_warehouse: 'Warehouse Integration {warehouseName} - {displayName} Failed',
      copied: 'Copied',
      success_title: 'Success',
      fail_title: 'Failed',
    },
    zalora_sync: {
      alert_msg: 'Orders entering Powerbiz will be automatically accepted by the system, but shipment is not yet set on Zalora. Please select one of the processes below for the Powerbiz system to update shipment on Zalora',
      select_shipment_label: 'Update Zalora Shipment',
      select_shipment_required: 'Select update zalora shipment',
      select_shipment_placeholder: 'Choose update zalora shipment',
      how_to_get_title: 'How to get Client ID & Secret :',
      step_1: 'Login to Zalora seller center',
      step_2: 'Go to settings menu',
      step_3: 'Select Integration Management',
      step_4: 'Select OAuth Application',
      step_5: 'Add New Application',
      step_6: 'Input data :',
      step_6_li_1: 'Application Name : Powerbiz',
      step_6_li_2: 'Authorization redirect URL : https://admin.powerbiz.asia/integration/zalora',
      step_7: 'If done, click save',
      step_8: 'Select the application created earlier, then click edit',
      step_9: 'Copy the generated Client ID & Client Secret',
      sales_items_booked: {
        label: 'Stock Allocated',
        tooltip: 'Stock Allocated: set shipment on Zalora will be set when stock is allocated',
      },
      pick_confirmed: {
        label: 'Picking',
        tooltip: 'Picking: set shipment on Zalora will be set when items have been picked from warehouse rack',
      },
    },
    sync_form: {
      success_title: 'Success!',
      success_desc: 'Your Tokopedia Store Integration process is in progress, please check your email.',
      disclaimer: 'This form is for Tokopedia integration request process',
      is_binding_label: 'Have you bound your Tokopedia with Tiktok Shop?',
      is_binding_required: 'Please select binding status',
      not_binding: 'Not bound yet',
      already_binding: 'Yes, Already bound',
      complete_info: 'Complete the following information',
      store_name: 'Store Name',
      store_name_required: 'Please input store name!',
      store_name_placeholder: 'Input store name',
      store_domain: 'Store Domain',
      store_domain_required: 'Please input store domain!',
      tokopedia_steps_title: 'Follow these steps to perform Tokopedia Integration:',
      tokopedia_steps: {
        1: 'Make a store integration request by inputting your Store Name and Domain. Your store status will be "Waiting" (Waiting for confirmation from Seller). Your store name and domain can be seen on Tokopedia seller center web > Store Settings > Information. Then copy store information in Store Domain section (just copy the text after "www.tokopedia.com/")',
        2: 'Tokopedia will send a store integration approval confirmation email to your store email address. You can also receive store integration approval via Tokopedia seller center web > Third Party Application Settings > Waiting for approval.',
        3: 'Then wait for the data verification process by Powerbiz for ± 1x24 hours. Verification process is complete, marked by your store status changing to "Pending Warehouse" in Store List. Powerbiz will also send a notification to your email address, informing that the verification process is complete.',
        4: 'Map your warehouse in Powerbiz with Tokopedia warehouse via store list menu.',
        5: 'Your store is ready to operate via Powerbiz.',
      },
      add_other_store: 'Add Other Store',
      finish: 'Finish',
      request_integration: 'Request Integration',
      close: 'Close',
      store_id_not_found: 'Store ID not found',
      connected_failed: 'Connected Failed',
    },
    note_tips_tiktok_tokopedia: 'You will be doing tiktok shop integration, this integration process will create 2 channels, namely tiktok & tokopedia, make sure tokopedia has been binding with tiktok, but if you have not done binding, then only tiktok will be registered in the powerbiz system. You can add tokopedia later, by doing store registration and click the "tokopedia" icon and select "Yes, already binding"',
    back: 'Back',
    sync_store_sucess: 'Store Integration Success',
    des_sync_store_sucess:
      'Please synchronize the products on your Store Product List by clicking the Sync button. Product.',
    add_more_store: 'Add More Stores',
    done_sync: 'Finish',
    cancel: 'Cancel',
    next: 'Next',
    choose_chanel: 'Choose a channel to integrate into your store',
    start_sync: 'Start Integration',
    complite_detail_information: 'Complete the following detailed information',
    select_shop: 'Select Shop',
    error_sync: 'An error occurred, please try again',
    complete_information: 'Complete the following detailed information',
    sync_warehouse: 'Warehouse Synchronization',
    main_warehouse: 'Main Warehouse',
    select_main_warehouse: 'Select Main Warehouse',
    channel_warehouse: 'Channel Warehouse',
    select_channel_warehouse: 'Select Channel Warehouse',
  },
  distributor: {
    list_distributor: 'List Distributor',
    search: 'Search Distributor',
    export_data: 'Export Data',
    add_distributor: 'Add Distributor',
    name_distributor: 'Name Distributor',
    category_distributor: 'Category',
    address: 'Address',
    action: 'Action',
    country: 'Country',
    indonesia: 'Indonesia',
    city: 'City',
    email: 'Email',
    status: 'Status',
    sla_day: 'Day SLA Complain',
    coverage_area: 'Coverage Area',
    district: 'District',
    subdistrict: 'Subdistrict',
    mobile_phone: 'Mobile Phone',
    active: 'Active',
    inactive: 'Not Active',
    add_success_desc: 'Distributor successfully added',
    add_failed_desc: 'Failed to add distributor',
    detail_distributor: 'Detail Distributor',
    active_condition: 'Deactivate',
    inactive_condition: 'Activate',
    status_distributor: '{value} Distributor',
    confirm_deactivate: 'Are you sure you want to {value} the distributor ?',
    code: 'Distributor Code',
    name: 'Distributor Name',
    npwp_id: 'NPWP ID',
    npwp_name: 'NPWP Name',
    postal_code: 'Postal Code',
    warehouse_code: 'Warehouse Code',
    warehouse_name: 'Warehouse Name',
    warehouse_address: 'Warehouse Address',
    use_distributor_address: 'Use Distributor Address',
    choose_city: 'Select City first',
    choose_district: 'Select District first',
    choose_coverage: 'Select Coverage Area City first',
    rules: {
      code: 'Distributor code is required',
      name: 'Distributor name is required',
      categories: 'Product category is required',
      phone_number: 'Mobile phone is required',
      taxid: 'NPWP number is required',
      taxname: 'NPWP name is required',
      bank_name: 'Bank name is required',
      account_number: 'Account number is required',
      account_name: 'Account name is required',
      sla_shipping_day: 'SLA Complain is required',
      city: 'City is required',
      district: 'District is required',
      postal_code: 'Postal code is required',
      address: 'Address is required',
      warehouse_name: 'Warehouse name is required',
      coverage: 'Coverage area is required',
    },
  },
  reseller: {
    titleHead: 'Reseller',
    search: 'Search reseller..',
  },
  customer: {
    customer_category: "Customer Category",
    add_customer_category: 'Add Customer Category',
    enter_category_name: 'Enter category name',
    create_success_category: 'Customer category created successfully',
    create_failed_category: 'Failed to create customer category',
    list: 'Customer List',
    search: 'Search Customer Data',
    export: 'Export Data',
    invite: 'Invite Customer',
    name: 'Customer Name',
    category: 'Customer Category',
    email: 'Email',
    mobile: 'Mobile Phone',
    distributor: 'Distributor',
    city: 'City',
    status: 'Status',
    action: 'Action',
    all: 'All Status',
    not_approved: 'Not Approved',
    active: 'Active',
    inactive: 'Inactive',
    approval: 'Approval',
    new: 'New',
    edit: 'Edit',
    credit_limit: 'Credit Limit',
    transaction_limit: 'Transaction Limit',
    payment_limit: 'Payment Limit',
    username: 'Username',
    active: 'Active',
    inactive: 'Inactive',
    select_city_first: 'Please Select City',
    edit_customer: 'Edit Customer',
    delete: 'Delete',
    empty_title: 'No data',
    empty_msg: "You don't have any data yet",
    add: 'Add Customer',
    password: 'Password',
    confirm_password: 'Confirm Password',
    distributor_city: 'Distributor City',
    select_category: 'Select Customer Category',
    select_city: 'Select Distributor City',
    select_distributor: 'Select Distributor',
    select_all: 'Select All',
    save: 'Save',
    cancel: 'Cancel',
    approve: 'Approve',
    not_approve: 'Not Approve',
    registration_via: 'Registration via Email / Mobile Phone',
    shop_code: 'Shop Code',
    buyer_code: 'Buyer Code',
    sales_code: 'Sales Code',
    store_name: 'Store Name',
    store_type: 'Store Type',
    store_types: {
      store: 'Store',
      reseller: 'Reseller',
      guest: 'Guest',
    },
    payment_model: 'Payment Model',
    payment_models: {
      cbd: 'Cash Before Delivery',
      cod: 'Cash On Delivery',
      cad: 'Cash After Delivery',
    },
    transaction_limits: 'Transaction Limits',
    coin_usage: 'Coin Usage',
    coin_flag: {
      yes: 'Yes',
      no: 'No',
    },
    limit_unit: {
      times: 'Times',
      days: 'Days',
      weeks: 'Weeks',
      months: 'Months',
    },
    pay_time_limit: 'Pay Time Limit',
    setup_credit_limit: 'Setup Credit Limit',
    credit_limit_total_label: 'Total Credit Limit',
    credit_limit_usage_label: 'Running Credit Limit',
    credit_limit_remaining_label: 'Remaining Credit Limit',
    user_status: 'User Status',
    phone: 'Phone Number',
    road_name: 'Street Name',
    distributor_list: 'Distributor List',
    search_distributor: 'Search distributor...',
    select_warehouse: 'Select warehouse',
    select_all_warehouse: 'Select All Warehouses',
    payment_info: 'If you choose CBD, you only get CBD; if you choose COD, you get CBD & COD; if you select CAD, you get everything',
    credit_limit_info: 'credit value owned by the customer',
    transaction_limit_info: 'maximum transaction limit for term payments',
    payment_limit_info: 'Billing payment time limit',
    notification: {
      cannot_delete_distributor: 'Cannot delete distributor',
      cannot_delete_distributor_desc: 'Action restricted, you cannot delete a distributor that has been previously added',
      failed_to_find_warehouse: 'Failed to find warehouse data',
      failed_to_select_warehouse: 'Failed to select warehouse',
      price_area_not_found_in_warehouse: 'Price area not found in warehouse {name}',
      distributor_not_found: 'Distributor data not found',
      save_success: 'Customer saved successfully',
      save_failed: 'Failed to save customer',
      failed_to_find_price_area: 'Failed to find price area',
      not_found_bill: 'No bills found',
    },
    rules: {
      payment_model_required: 'Payment model is required',
      distributor_required: 'Distributor must be selected',
      warehouse_required: 'At least 1 warehouse must be selected',
      credit_limit_required: 'Credit limit is required',
      transaction_limit_required: 'Transaction limit is required',
      payment_limit_required: 'Payment time limit is required',
      credit_limit_usage_error: 'You currently have bills and your running credit limit value: {value}, cannot be smaller than the value the customer currently has',
      transaction_limit_usage_error: 'You currently have bills and your current transaction limit value: {value}, cannot be smaller than the value the customer currently has',
      name: 'Store name is required',
      namecustomer: 'Customer name is required',
      category: 'Category must be selected',
      email: 'Email is required',
      email_invalid: 'Email is invalid',
      mobile: 'Mobile phone is required',
      road_name: 'Street name is required',
      country: 'Country must be selected',
      city: 'City is required',
      subdistrict: 'Sub-district must be selected',
      postcode: 'Postcode is required',
      password: 'Password is required',
      confirm_password: 'Confirm password is required',
      distributor: 'Distributor must be selected',
      city: 'Distributor city must be selected',
      password: 'Password is required',
      confirm_password: 'Confirm password is required',
      match_password: 'Confirm password must be the same as password',
      sales_code: 'Sales code must be selected',
      coin_usage: 'Coin Usage must be selected',
      shop_code: 'Shop Code is required',
      category_name_required: 'Category name is required',
      max_char: 'Maximum {max} characters',
      road_name_required: 'Street name is required',
      country_required: 'Country is required',
      city_required: 'City is required',
      subdistrict_required: 'Subdistrict is required',
      postcode_required: 'Postal code is required',
      payment_model_required: 'Payment model is required',
      credit_limit_required: 'Credit limit is required',
      transaction_limit_required: 'Transaction limit is required',
      payment_limit_required: 'Payment limit is required',
      distributor_required: 'Distributor is required',
      warehouse_required: 'At least 1 warehouse must be selected',
      credit_limit_warning: 'You currently have bills and your running credit limit: {limit}, cannot be smaller than the value owned by the customer currently',
      transaction_limit_warning: 'You currently have bills and your current transaction limit: {limit}, cannot be smaller than the value owned by the customer currently',
      distributor_delete_restricted: 'This action is restricted, you cannot delete a distributor that has been previously added',
      distributor_delete_restricted_title: 'Cannot delete distributor',
      price_area_fetch_failed: 'Failed to find price area',
      warehouse_fetch_failed: 'Failed to find warehouse data',
      price_area_not_found: 'Price area not found in warehouse {warehouse}',
    },
    deactivate: 'Deactivate',
    activate: 'Activate',
    checkCustomerBill: 'Check Customer Bill',
    confirmDeactivate: 'Are you sure you want to deactivate customer',
    confirmActivate: 'Are you sure you want to activate customer',
    approveSuccess: 'Customer approved successfully',
    approveFailed: 'Failed to approve, an error occurred.',
    deactivateSuccess: 'Customer deactivated successfully',
    activateSuccess: 'Customer activated successfully',
    saveSuccess: 'Customer saved successfully',
    saveFailed: 'Failed to save customer',
    payment_models: {
      cbd: 'Cash Before Delivery',
      cod: 'Cash On Delivery',
      cad: 'Cash After Delivery',
    },
  },
  order: {
    storeName: 'Store Name',
    customerDetail: 'Customer Detail',
    customerName: 'Name',
    customerPhone: 'Phone Number',
    customerEmail: 'Email',
    paymentDetail: 'Payment Detail',
    totalPriceOrder: 'Total Price Order',
    paymentStatus: 'Payment Status',
    paymentMethod: 'Payment Method',
    orderShippingDetail: 'Shipping Detail',
    courier: 'Courier',
    warehouse: 'Warehouse',
    detail: 'Order Detail',
    voucher: 'Voucher',
    salesTitle: 'Sales',
    shippingCost: 'Shipping Cost',
    itemsSold: 'Items Sold',
    cleanFilter: 'Clean Filter',
    totalAllSales: 'Total All Sales',
    exportTitle: 'Export',
    export_data: 'Export Data',
    orderDate: 'Orders Date',
    business: 'Business',
    channel: 'Channels',
    customer: 'Customers',
    orderNumber: 'Orders No',
    orderType: 'Order Type',
    priorityLevel: 'Priority',
    itemTotal: 'Total Item',
    priceTotal: 'Price Total',
    productName: 'Product name',
    skuTitle: 'SKU',
    quantityTitle: 'Qty',
    shippingTitle: 'Shipping Details',
    priceTitle: 'Price',
    discountTilte: 'Discount',
    totalTitle: 'Sub Total Order',
    detailsTitle: 'Details',
    viewDetail: 'View Detail',
    closeDetail: 'Close Detail',
    history_order_log: 'Order History',
    history_order_title: 'Order History',
    history_activities: 'Recorded Activities',
    history_empty_msg: 'No log history found for this order.',
    history_failed_to_load: 'Failed to Load Order History',
    history_fetch_error_desc: 'An error occurred while fetching log from server.',
    sort_newest: 'Newest First',
    sort_oldest: 'Oldest First',
    no_activity: 'No activity',
    paymentsTotalTitle: 'Total Bill',
    moreDetailsTitle: 'Show More Details',
    lessDetailsTitle: 'Show Less Details',
    sortBy: 'Sort By',
    sortByNewest: 'Newest',
    sortByOldest: 'Oldest',
    dropshipperInformation: 'Send as dropshipper',
    dropshipperAddress: 'Dropshipper Address',
    shippingCourierTitle: 'Courier',
    shippingReceiptNumber: 'Receipt No',
    shippingLabel: 'Shipping Label',
    shippingWarehouseTitle: 'Send From',
    shipping_id: 'Shipping ID',
    shippingAddress: 'Shipping Address',
    pickup_address: 'Pickup Address',
    shippingHistoryTitle: 'Shipping History',
    shippingShowMoreDetailsTitle: 'Show More Details',
    viewHistory: 'View History',
    closeHistory: 'Close History',
    changesHistory: 'History',
    unmapped_products_warning: 'This order contains unmapped products',
    instant_courier_info: 'This order uses instant courier',
    ordersPeriod: 'Order Period',
    ordersPeriodFrom: 'Order Period Start',
    ordersPeriodUntil: 'Order Period End',
    productCategory: 'Product Category',
    printStatus: 'Print Status',
    date_created: 'Date Created',
    last_modified: 'Last Modified',
    order: 'Order',
    oldest_first: 'Oldest First',
    newest_first: 'Newest First',
    filterState: {
      all: 'All',
      verified: 'Unpaid',
      submitted: 'Created',
      new_: 'Created',
      confirmed: 'Pending',
      onprocess: 'On Process',
      on_process: 'On Process',
      cancelrequested: 'Confirm cancellation',
      shipped: 'On Delivery',
      send: 'Delivered',
      delivered: 'Delivered',
      canceled: 'Canceled',
      completed: 'Completed',
      ready_to_ship: 'Ready to Send',
      cancel_requested: 'Req to Cancel',

    },
    filterStateTag: {
      all: 'All',
      verified: 'Unpaid',
      new: 'Created',
      new_: 'Created',
      confirmed: 'Pending',
      onprocess: 'On Process',
      on_process: 'On Process',
      cancelrequested: 'Conf. cancellation',
      shipped: 'On Delivery',
      send: 'Delivered',
      delivered: 'Delivered',
      canceled: 'Canceled',
      completed: 'Completed',
      ready_to_ship: 'Rdy to Send',
      cancel_requested: 'Req to Cancel',

    },
    status: {
      confirmOrder: 'Confirm Order',
      completedOrder: 'Completed Order',
    },
    require_order_period: 'Please fill in the order period',
    empty_title: 'No data',
    empty_msg: "You don't have any data yet",
    courier_name: 'Courier name',
    accept_order: 'Accept Order',
    reject_order: 'Reject Order',
    cancel_order: 'Cancel Order',
    cancel_request: 'Refuse Cancellation',
    accept_with_shipment: 'Accept Order with Shipment',
    arrange_shipment: 'Arrange Shipment',
    channel_accept_success: 'Order {order_number} successfully processed',
    channel_accept_already_accepted: 'Order {order_number} has already been processed before',
    channel_accept_failed: 'Failed to process order {order_number}',
    channel_accept_shipment_delay_title: 'Arrange Shipment postponed.',
    channel_accept_shipment_delay_description: 'Shipment arrangement is outside the acceptance window. The system will',
    channel_accept_shipment_delay_retry: 'automatically retry at {retry_at}.',
    cancel_reason: 'Cancellation Reason',
    cancel_reason_sub: 'Cancel Reason',
    cancel_detail: 'Cancellation details',
    select_empty_stock: 'Select empty stock',
    placeholder_cancel_detail: 'Explain the reason for canceling your order',
    info_cancel_detail: 'Minimum {value} characters',
    novalid_reason: 'Please choose a reason',
    accept_confirm_msg: 'Are you sure you want to accept this order?',
    transaction_discount: 'Transaction Discount',
    transaction_deposit: 'Deposit',
    transaction_loyalty: 'Loyalty',
    transaction_voucher: 'Voucher',
    transaction_shipping: 'Shipping Cost',
    transaction_admin: 'Total Admin Fees',
    discount_transaction: 'Transaction Discount by',
    discount_shipping: 'Shipping Discount by',
    tracking: {
      delivery: {
        waiting: 'Waiting',
        waitingTooltip: 'Package in processing queue',
        picking: 'Picking',
        pickingTooltip: 'Package has been picked from warehouse',
        packing: 'Packing',
        packingTooltip: 'Package has been packed',
        readyToShip: 'Ready to Ship',
        readyToShipTooltip: 'Package has been good issued',
      },
      shipping: {
        waiting: 'Waiting',
        waitingTooltip: 'Package is ready to be shipped',
        delivery: 'Delivery',
        deliveryTooltip: 'Package is in delivery',
        delivered: 'Delivered',
        deliveredTooltip: 'Package has arrived',
        completed: 'Completed',
        completedTooltip: 'Order has been completed',
      },
    },
    pickup_address: 'Pickup Address',
    export_mode: 'Export Mode',
    export_order_data: 'Export Sales Data',
    export_excel: 'Export Excel',
    total_sales_data: 'Total Sales Data',
    filter_state_title: 'Order Status',
    choose_order_status: 'Choose Order Status',
    choose_order_type: 'Choose Order Type',
    choose_priority_level: 'Choose Priority',
    choose_business: 'Choose Business',
    choose_channel: 'Choose Channel',
    choose_warehouse: 'Choose Warehouse',
    choose_sales_channel: 'Choose Sales Channel',
    disclaimer_max_data: 'Please re-select the date filter, the maximum that can be downloaded is 500 data',
    max_date_range_error: 'Maximum date range for export data is {limit} days.',
    current_date_range_info: 'The date range you choose is currently {count} days',
    order_item_status: 'Order Item Status',
    choose_order_item_status: 'Choose Order Item Status',
    all_order_type: 'All Order Type',
    all_priority_level: 'All Priority',
    all_status: 'All Status',
    all_business: 'All Business',
    all_channel: 'All Channel',
    all_sales_channel: 'All Sales Channel',
    all_warehouse: 'All Warehouse',
    confirmed: 'Confirmed',
    unconfirmed: 'Unconfirmed',
    cancel_order: 'Cancel Order',
    internal_cancel_order: 'Internal - Cancel Order',
    cannot_cancel_fulfillment_started: 'Sorry, this order number cannot be canceled, because the fulfillment process is in progress.',
    yes_cancel_order: 'Yes, Cancel Order',
    no_title: 'Title data is null',
    not_mapped: 'This product has not been mapped yet',
    no_data_show: 'There is no data to show',
    pick_up_admin: 'Pick Up Admin',
    cad_detail: 'CAD Detail',
    processing_data: 'Data is being processed, please try again in a few moments.',
  },
  integration: {
    integration: 'Integration',
    name: 'Name',
    channelManagement: 'Channel Management',
    warehouseManagement: 'Warehouse Management',
    shippingManagement: 'Shipping Management',
    pointOfSales: 'Point Of Sales',
    paymentGateway: 'Payment Gateway',
    accounting: 'Accounting',
    addChannel: 'Add Channel',
    addWarehouse: 'Add Warehouse',
    addShipping: 'Add Shipping',
    addPointOfSales: 'Add Point Of Sales',
    addPaymentGateway: 'Add Payment Gateway',
    addAccountingTool: 'Add Accounting Tool',
    startIntegration: 'Start Integration',
    confirmProduct: 'Product Confirmation',
    editChannel: 'E d i t',
    deleteChannel: 'Delete Channel',
    empty_store_title: 'No Store or Sales Channel Yet',
    empty_store_desc: 'Currently your account does not have a store or sales channel. <br /> Please add a store and integrate with our system.',
    search_sales_channel_placeholder: 'Search Store or Sales Channel',
    add_store: 'Add Store',
    store_name: 'Store Name',
    store_status: 'Store Status',
    authorization_time: 'Authorization Time',
    country: 'Country',
    notes: 'Notes',
    options: 'Options',
  },
  product: {
    productTags: {
      title: 'Product Tags',
      add_new: 'Add new tag',
      tabs: {
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
      },
      table: {
        name: 'Tag Name',
        status: 'Status',
      },
      action: {
        deactivate: 'Deactivate',
        activate: 'Activate',
        see_details: 'See details',
        edit: 'Edit',
        manage_products: 'Manage Products',
      },
      modal: {
        add_title: 'Add New Tag',
        edit_title: 'Edit Tag',
        subtitle: 'Enter tag name for each language',
        field_name: 'Tag Name',
        required: 'required',
        optional: 'optional',
        default: 'Default',
        set_as_default: 'Set as default',
        sequence: 'Sequence',
        status: 'Status',
        cancel: 'Cancel',
        submit: 'Submit',
      },
      detail: {
        title: 'Product Tag Detail',
        id: 'ID',
        name_id: 'Name (ID)',
        name_en: 'Name (EN)',
        status: 'Status',
      },
      messages: {
        fetch_failed: 'Failed to fetch data',
        fetch_detail_failed: 'Failed to fetch tag detail',
        save_success: 'Saved successfully',
        save_failed: 'Failed to save data',
        status_updated: 'Status {name} updated',
        status_update_failed: 'Failed to update status',
        detail_fetch_failed: 'Failed to fetch detail',
        id_required: 'ID name is required',
        en_required: 'EN name is required',
        set_default_success: '{lang} set as default',
      },
      manage: {
        title: 'Manage Product Tags',
        add_product: 'Add Product',
        remove_product: 'Remove from Tag',
        modal_title: 'Select Products for Tag',
        table: {
          product: 'Product',
          sku: 'SKU',
          price: 'Price',
          stock: 'Stock',
        },
        messages: {
          add_success: 'Product successfully added',
          add_failed: 'Failed to add product',
          remove_success: 'Product successfully removed from tag',
          remove_failed: 'Failed to remove product from tag',
          fetch_products_failed: 'Failed to fetch product list',
        },
        empty_description: 'Select tag to view products',
        no_tags: 'No tags available',
        search_placeholder: 'Search product name or SKU...',
        tagged: 'Tagged',
        add: 'Add',
      },
    },
    title: 'Product',
    listProduct: 'List Product Master',
    priceArea: 'Price Area',
    per_area: 'Per Area',
    select_photo: 'Select Photo',
    upload_image_hint: 'Please upload image in {section} section',
    photo_video_section: 'Photo and Video',
    area: 'Area',
    customer_type: 'Customer Type',
    price: 'Price',
    effective_date: 'Effective Date',
    quantity: 'Quantity',
    product_bundling: 'Product Bundling',
    soft_bundling: 'Soft Bundling',
    hard_bundling: 'Hard Bundling',
    no_bundling: 'None',
    delete_bundling_confirm_title: 'Delete Bundling',
    delete_bundling_confirm_content: 'If you change it, the bundle product list will be deleted, are you sure?',
    searchBarPlaceholder: 'Search',
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    addPrice: 'Add Price',
    clearFilter: 'Clear filter',
    setfilter: 'Set filter',
    date: {
      first: 'First date',
      end: 'End date',
    },
    select_date: 'Select date',
    productStatus: {
      ACTIVE: 'Active',
      NON_ACTIVE: 'Inactive',
      INACTIVE: 'Inactive',
      DRAFT: 'Draft',
    },
    slug: 'Slug',
    slug_disclaimer: 'The slug format does not match the standard. Please click the <b>Edit</b> button to adjust it automatically.',
    slug_error: 'Failed to get a unique number for the slug. Please click the "Edit" button again to try again.',
    addNewProduct: 'Add New Product',
    uploadTemplate: 'Upload Template',
    cancel: 'Cancel',
    next: 'Next',
    selectClient: 'Choose Client',
    mass_change: 'Bulk Update',
    all_select: 'All',
    selected: 'Selected',
    delete: 'Delete Product',
    delete_product_confirm_title: 'Delete Product',
    delete_product_confirm_content: 'Are you sure you want to delete the {name} product ?',
    export: 'Export',
    product_name: 'Product Name',
    categories: 'Categories',
    varian: 'Variant',
    variant: '{count} Variants | {count} Variant | {count} Variants',
    variant_name: 'Variant Name',
    variant_label: 'Variant',
    add_variant: 'Add variant',
    type_variant_option: 'Type option',
    variant_remove_confirm: 'If deleted, the entered variant data will change and the variant type will disappear from the variant options.',
    variant_list_empty: 'Variant list is not yet complete',
    variant_list_empty_desc: 'Complete the variant data above to fill in the variant details',
    product_variant: 'Product Variants',
    variant_desc:
      'Choose one to set Unit Product type, Bundling Product, Variant Product',
    variant_options: 'Variant Options',
    product_type: 'Product Type',
    non_variant: 'Non-Variant',
    delete_variant_confirm_title: 'Delete Variant',
    delete_variant_confirm_content: 'If changed, the entered variant data will change and the variant type will disappear from the variant choices.',
    delete_variant_confirm_ok: 'Yes, Delete',
    range_price: 'Price Range',
    channel: 'Channel',
    status: 'Status',
    product_empty: 'No Products Yet',
    have_no_product: 'You dont have product yet, please Add Product.',
    product_details: 'Product Details',
    photo_video: 'Photos and Videos',
    product_image: 'Product Image',
    set_main: 'Set Main',
    set_thumbnail: 'Set Thumbnail',
    slug_description: 'Slug is used as a URL identification for this product. Slug may only contain letters, numbers and minus signs ( - ). Or you can automatically',
    generate_slug_here: 'generate slug here',
    status_description: 'Activate the product if you want to make this product purchasable by buyers',
    brand_placeholder: 'Search & Select Product Brand',
    slug_error_regex: 'Slug may only contain letters, numbers and minus signs ( - )',
    condition_new: 'New',
    condition_used: 'Used',
    origin_local: 'Local',
    origin_import: 'Import',
    short_description: 'Short Description',
    long_description: 'Full Description',
    confirm_delete_photo: 'Are you sure you want to delete this photo?',
    delete_photo: 'Delete',
    main: 'Main',
    thumbnail: 'Thumbnail',
    product_type_and_price: 'Product Type and Price',
    weight_product_shipping: 'Weight Product and Shipping',
    inventory: 'Inventory',
    channel_publication: 'Channel Publication',
    no_channels_integrated: 'No channels integrated yet.',
    confirm_remove_channel: 'Are you sure you want to remove this channel?',
    selected_channels: 'Selected Info',
    select_channel: 'Select Channel',
    add_channel: 'Add Channel',
    not_supported: 'Not supported',
    must_be_selected: '{name} must be selected',
    product_information: 'Product Information',
    brand: 'Product Brand',
    search_select_brand: 'Search & Select Product Brand',
    item_condition: 'Item Condition',
    non_physical_product: 'Non-Physical Product',
    specification: 'Specification',
    used_condition: 'Used',
    description: 'Description',
    short_description: 'Short Description',
    photo_title: 'Product Photos',
    product_name: 'Product Name',
    max_70_characters: 'Max. 70 Characters',
    bundle_list_empty: 'Bundle product list to be filled',
    remove_bundle_item_confirm: 'Are you sure want to remove this product from the bundle list?',
    add_bundle_product: 'Add bundle product',
    search_product: 'Search product',
    enter_product_title_sku: 'Enter product title / SKU',
    choose_warehouse_first: 'Choose warehouse first',
    search_min_2_chars: 'Type at least 2 characters to search for products',
    sku_not_in_warehouse: 'SKU does not exist in one of the warehouses you selected, please add the warehouse first for that SKU',
    variant_name: 'Variant Name',
    variant_label: 'Variant',
    type_variant_option: 'Type variant option',
    add_variant: 'Add variant',
    variant_list_empty: 'Variant list is not complete',
    variant_list_empty_desc: 'Complete the variant data above to fill in the variant details',
    variant_remove_confirm: 'If changed, the entered variant data will change and the variant type will disappear from the variant choices.',
    sku_already_registered_simple: 'SKU already registered',
    product_save_success: 'Changes successfully saved',
    product_draft_save_success: 'Draft product successfully saved',
    product_save_failed_prefix: 'Oops, product failed to save! {message}',
    product_image_save_success: 'Product images successfully saved',
    product_image_save_failed: 'Oops, product images failed to save',
    product_catalog_save_failed: 'Oops, product catalog failed to save',
    weight_shipping_save_failed: 'Oops, product weight and shipping failed to save',
    try_again_later: 'Please try again later',
    product_not_found: 'Product not found',

    foto_video_description:
      'Upload photos and variants that the product has. Minimum photo dimensions are {minWidth}x{minHeight} px. The maximum file size is 1MB. With JPG, JPEG, PNG, BMP, GIF formats.',
    foto_video_description_master:
      'Upload photos and variants that the product has. Minimum photo dimensions are {minWidth}x{minHeight} px. The maximum file size is 10MB. With JPG, JPEG, PNG, BMP, GIF formats.',
    video_title: 'Product Videos',
    video_description:
      'Upload a product video up to 30MB or enter the youtube video link of the product',
    picture: 'Picture',
    base_unit: 'Base Unit',
    gift_size: 'Box Size',
    unit: 'Unit',
    weight_unit: 'Weight Unit',
    weight: 'Weight',
    width: 'Width',
    height: 'Height',
    length: 'Length',
    additional_unit: 'Additional Unit',
    sku_duplicate_variant: 'SKU cannot be the same as other variants',
    product_price: 'Product Price',
    quantity_conversion: 'Quantity Conversion',
    add_new_unit: 'Add New Unit',
    product_weight_per_unit: 'Product Weight / {unit}',
    confirm_remove_unit: 'Are you sure you want to delete the {unit} unit?',
    validate_unit_required: 'Unit is required',
    validate_unit_min: 'Unit must be greater than 0',
    validate_unit_conversion: 'Unit must be greater than conversion',
    use_price_area: 'Use Price per Area',
    add_warehouse: 'Add Warehouse',
    add_another_warehouse: 'Add Another Warehouse',
    select_warehouse: 'Select Warehouse',
    warehouse: 'Warehouse',
    stock: 'Inventory',
    main_warehouse: 'Main Warehouse',
    add_warehouse_location: 'Add Warehouse Location',
    search_select_warehouse: 'Search & Select Warehouse',
    apply: 'Apply',
    confirm_remove_warehouse: 'Are you sure you want to delete this warehouse from the inventory list?',
    validate_warehouse_required: 'Warehouse is required',
    select_warehouse_validation: 'Select at least one warehouse for this product',
    availability: 'Availability',
    on_hand: 'On Hand',
    preorder: 'Preorder',
    change_unit: 'Change Unit',
    confirm_change_base_unit: 'If changed, all additional units will be deleted. Do you want to change the unit from {oldUnit} to {newUnit}?',
    package_size: 'Package Size',
    physical_product: 'Physical Product',
    product_unit: 'Product Unit',
    weight_unit: 'Weight Unit',
    weight_value: 'Weight Value',
    width_value: 'Width Value',
    length_value: 'Length Value',
    height_value: 'Height Value',
    dangerous_product: 'Dangerous Product',
    dangerous_product_desc: 'Please fill in the Dangerous Product information correctly. Incorrect Dangerous Product information can increase shipping costs or result in shipping failure.',
    item_dangerous_content: 'Contains battery/magnet/liquid/flammable material',
    shipping_fee: 'Shipping Fee',
    seller_bears_shipping: 'Seller Bears Shipping Fee',
    supported_logistic_service: 'Supported Logistic Service',
    change_logistic_status: 'Change Logistic Service Status: {name}',
    i_will_bear_shipping: 'I will bear the shipping fee',
    shipping_fee_note: 'Shipping settings will only be applied to this product. The shipping fee displayed is the base rate which may change based on weight & buyer location.',
    shipping_insurance: 'Shipping Insurance',
    mandatory: 'Mandatory',
    optional: 'Optional',
    item_return: 'Item Return',
    item_can_be_returned: 'Item Can Be Returned',
    item_cannot_be_returned: 'Item Cannot Be Returned',
    cod: 'Cash On Delivery',
    shipping: 'Shipping',
    shipping_weight: 'Shipping Weight',
    product_stock: 'Product Stock',
    make_main_warehouse: 'Set as Main Warehouse',
    main_stock: 'Main Stock',
    allocated_stock: 'Allocated Stock',
    channel_stock: 'Channel Stock',
    product_not_synced: 'Product Not Synchronized',
    location: 'Location',
    make_main: 'Make Main',
    factory_sku: 'Factory SKU',
    barcode: 'Barcode',
    set_wholesale_price: 'Set Wholesale Price',
    add_wholesale_price: 'Add Wholesale Price',
    error_empty_variant: 'Variant name should not be empty',
    use_formula: 'Use Formula Calculation',
    dropshipper_commission: 'Dropshipper Commission',
    commission_level: 'Commission {level}',
    no_promotion_set: 'No promotion set.',
    promo_type: 'Type',
    promo_effective_date: 'Effective Date',
    promo_discount: 'Discount',
    promo_final_price: 'Price after discount',
    promo_until: 'until',
    promo_delete_confirm: 'This action cannot be undone! Are you sure you want to delete this discount?',
    promo_delete_btn: 'Delete discount',
    promo_add_title: 'Add promotion',
    promo_start_date: 'Start date',
    promo_end_date: 'End date',
    promo_amount: 'Amount',
    promo_percentage: 'Percentage',
    promo_nominal: 'Nominal',
    promo_regular: 'Regular',
    promo_flash_sale: 'Flash Sale',
    gallery_max_upload_left: 'You can upload maximum {count} images left',
    gallery_min_dimension: 'Minimum photo dimensions are {width}x{height} px',
    gallery_cannot_delete_main_thumb: 'Cannot delete Main and Thumbnail images',
    import_page: {
      title: 'Import New Products',
      non_variant: 'Non Variant',
      multi_variant: 'Multi Variant',
      create_bundling: 'Create Product Bundling',
      easy_way_desc: 'Easy way to add multiple products at once.',
      download_template_title: 'Download Template',
      download_template_desc: 'This file has the data that Powerbiz needs to import your data correctly.',
      download_template_btn: 'Download Template',
      upload_template_title: 'Upload Template',
      upload_template_desc: 'After completing the template, please upload the file. The file you upload must be in xlsx or xls format.',
      upload_template_btn: 'Upload Template',
      select_file: 'Select File',
      import_data_title: 'Import Data',
      success_message: 'Congratulations, data has been successfully imported. Please check the results on',
      failed_all_message: 'Sorry. Your data import process failed, all data failed to import. Please check the file you uploaded again.',
      failed_partial_message: 'Sorry. Your data import process failed, there are',
      failed_data: 'data that failed',
      failed_master_data: 'master data',
      failed_bundling_data: 'bundling data',
      data_master: 'Data Master',
      data_bundling: 'Data Bundling',
      row: 'Row',
      note: 'Note',
      active_processes_title: 'Active Processes',
      process_history_title: 'Process History',
      clear_completed: 'Clear Completed',
      in_progress: 'In Progress',
      cancel_process: 'Cancel Process',
      view_details: 'View Details',
      validating_excel: 'Validating Excel data... Please wait',
      started_at: 'Started at',
      started_at_label: 'Started At',
      processing_wait: 'Processing... Please wait',
      waiting_resources: 'Waiting for resources...',
      skus_processed: 'SKUs processed',
      stop_process_confirm: 'Stop this process?',
      stop_btn: 'Stop',
      keep_btn: 'Keep',
      file_name_label: 'File Name',
      total_label: 'Total',
      success_label: 'Success',
      failed_label: 'Failed',
      skipped_label: 'Skipped',
      action_label: 'Action',
      uploaded_by_label: 'Uploaded By',
      reupload_tip: 'Need to update some SKUs? You can always <b>re-upload</b> the template above.',
      process_details_title: 'Process Details',
      sku_label: 'SKU',
      status_label: 'Status',
      message_label: 'Message',
      processing_file: 'Processing file...',
      of: 'of',
    },
    bulk_publish: {
      title: 'Bulk Publish Channel Product',
      easy_way_desc: 'Easy way to publish multiple products at once.',
      form_title: 'Bulk Publish Form',
      step_1: 'Step 1',
      step_1_desc: 'Please select Shopee channel category first.',
      shopee_category: 'Shopee Channel Category',
      toco_category: 'Toco Channel Category',
      step_2: 'Step 2',
      step_2_desc: 'Select product from left list, then click ">" to move product to right. Click "<" to remove product from right list if you don\'t want to publish it.',
      master_product_list: 'Master Product List',
      not_registered_desc: 'This product is not registered in channel yet',
      publish_list: 'List of Products to Publish',
      will_publish_desc: 'This product will be published to channel',
      add_tooltip: 'Add product to publish list',
      remove_tooltip: 'Remove product from publish list',
      step_3: 'Step 3',
      step_3_desc: 'Make sure you fill mandatory attributes for each product. However if all optional, product can be published immediately.',
      fill_via_excel: 'You can fill all at once using excel upload feature, click',
      here: 'here',
      success_publish: 'Successfully Published Products',
      cancel_confirm: 'Are you sure you want to cancel this process? You will restart from beginning if you cancel.',
      yes_cancel: 'Yes, Cancel Publish',
      no: 'No',
      cancel: 'Cancel',
      back_step: 'Back to previous step',
      next: 'Next',
      publish_confirm_title: 'Are you sure? Make sure entered data is correct. If there is mistake you have to edit from marketplace (shopee).',
      yes_publish: 'Yes, Publish Product',
      check_again: 'Check Again',
      publish_btn: 'Publish Product',
      close: 'Close',
      category_required: 'Category is required',
      row: 'Row',
      note: 'Note',
      product_name: 'Product Name',
      product_attribute: 'Product Attribute',
      upload_modal: {
        title: 'Upload Form Attribute',
        upload_loading: 'Uploading file...',
        download_template: 'Download file template',
        here: 'here',
        upload_your_file: 'Upload your file',
        drag_text: 'Upload excel attribute file that has been filled',
        submit: 'Submit Form Attribute',
        failed_title: 'Failed',
        no_product_selected: 'No product selected',
        product_sku: 'Product SKU',
        product_name: 'Product Name',
        mandatory: '(Mandatory)',
        optional: '(Optional)',
      },
    },
    totalItemPrice: 'Total Item Price',
    productBundling: 'Bundling Products',
    product_bundling: 'Product Bundling',
    soft_bundling: 'Soft Bundling',
    hard_bundling: 'Hard Bundling',
    product_name_bundling: 'Product Name',
    quantity_bundling: 'Quantity',
    no_data: 'No Data',
    add_product: 'Add Product',
    add_product_bundling: 'Add Bundling Product',
    search_product: 'Search Product',
    enter_product_name_sku: 'Enter product name / SKU',
    select_warehouse_first: 'Select warehouse first',
    min_chars_search: 'Type at least 2 characters to search products',
    remove_bundling_confirm: 'Are you sure you want to remove this product from the bundling list?',
    sku_not_in_warehouse: 'SKU is not available in one of the warehouses you selected, please add the warehouse first for that SKU',
    add_unit: 'Add Unit',
    variant_list: 'Variant List',
    add_variant: 'Add Variant',
    variant_label: 'Variant',
    type_variant_option: 'Type option',
    variant_name_required: 'Variant Name is required',
    variant_name_duplicate: 'Variant Name already exists',
    variant_list_required: 'Variant List is required',
    variant_remove_confirm: 'If deleted, the variant data that has been entered will change and the variant type will disappear from the variant options.',
    bundling_list_empty: 'Bundling product list is empty',
    variant_list_empty: 'Variant list is not yet complete',
    variant_list_empty_desc: 'Complete the variant data above to fill in the variant details',
    tambah_produk_bundling_modal: 'Add bundling product',
    cari_produk_label: 'Search product',
    masukkan_judul_produk_sku: 'Enter product title / SKU',
    calc_price: 'Item Calculation Price',
    import: 'Product Import',
    importLabel: 'Item Origin',
    'price-include-vat': 'Price Include VAT',
    'price-exclude-vat': 'Price Exclude VAT',
    'price-no-vat': 'Price Not Charge for VAT',
    write_something: 'Write something',
    import_export: 'Import / Export',
    import_change_price: 'Import Change Price',
    export_product_data: 'Export Product Data',
    price_area: 'Price Area',
    area: 'Area',
    customer_type: 'Customer Type',
    price: 'Price',
    effective_date: 'Effective Date',
    add_price: 'Add Price',
    stock_allocation: 'Stock Allocation',
    allocated_stock: 'Allocated Stock',
    catalog: 'Catalog',
    set_allocation_stock: 'Set Allocation Stock',
    enter_value_or_percentage: 'Enter Value or Percentage Allocation',
    apply_to_all: 'Apply to All',
    channel_id: 'Channel ID',
    sales_channel: 'Sales Channel',
    allocation_success: 'Stock allocation successfully saved',
    allocation_failed: 'Stock allocation failed to save',
    allocated_stock: 'Allocated Stock',
    catalog: 'Catalog Product',
    product_category: 'Product Category',
    category_name: 'Category Name',
    new_product: 'Newest Product',
    old_product: 'Oldest Product',
    view_variant: 'View Variant',
    close_variant: 'Close Variant',
    sortProduct: 'Sort Product',
    import: 'Import',
    detail: 'Detail',
    nonVariant: 'Non Variant',
    bundling: 'Bundling',
    draft: 'Draft',
    republish_product: 'Republish Product',
    republish_multi_product: 'Republish Multi Product',
    selectFirst: 'Please select {name} first',
    accessDenied: 'Access Denied',
    accessDeniedDesc: 'Sorry, you do not have access to {page} this product.',
    exportSuccess: 'Export process successful',
    exportFailed: 'Export Data Failed',
    exportFailedDesc: 'Export Master Product Data failed',
    exportFailedAllocation: 'Export Allocation Stock Data failed',
    unitNamePlaceholder: 'Unit Name',
    changeUnitTitle: 'Change Unit',
    changeUnitContent: 'If changed, all additional units will be deleted. Do you want to change the unit from {old} to {new} ?',
    changeUnitOk: 'Change Unit',
    validateUnitRequired: 'Unit is required',
    validateUnitMin: 'Unit must contain at least 2 characters',
    validateUnitExist: 'Unit already exists',
    validateNameRequired: 'Product Name is required',
    validateCategoryRequired: 'Category is required',
    validateDescriptionRequired: 'Description is required',
    validateImageRequired: 'Upload at least 1 product image',
    validateInventoryRequired: 'Inventory is required',
    invalidData: 'There is invalid data. Please check your input again',
    saveSuccess: 'Product saved successfully!',
    saveFailed: 'Failed to save product!',
    editProduct: 'Edit Product',
    notFound: 'Product not found',
    errorOccurred: 'An error occurred',
    backToPrevious: 'Back to previous page',
    defaultCategory: 'Default Product Category',
    channelCategory: 'Channel Product Category',
    activationSuccess: 'Product Activation Success',
    activationFailed: 'Product Activation Failed',
    republishSuccess: 'Republish Product Success',
    republishFailed: 'Republish Product Failed',
    collection: {
      title: 'Product Collection',
      type: {
        featured: 'Featured',
        bestseller: 'Best Seller',
        newarrival: 'New Arrival',
        special: "Special",
      },
      confirm: {
        delete: 'Are you sure want to delete this product from product collection?',
      },
      'add-to-collection': 'Add to collection',
      'type-label': 'Type',
    },
    bulk_edit_product: 'Bulk Edit Product',
    upload_bulk_edit_product: 'Upload Bulk Edit Product',
  },
  global_variable: {
    add: 'Add Global Variable',
    empty_title: 'No global variable yet',
    empty_msg: 'You dont have global variable yet',
  },
  formula_variable: {
    add: 'Add Formula Variable',
    empty_title: 'No formula variable yet',
    empty_msg: 'You dont have formula variable yet',
  },
  product_variable: {
    add: 'Add Product Variable',
    empty_title: 'No product variable yet',
    empty_msg: 'You dont have product variable yet',
  },
  price_formula: {
    price_formula: 'Price Formula',
    search: 'Search',
    add_price_formula: 'Add Price Formula',
    all: 'Select All',
    formula_name: 'Formula Name',
    short_description: 'Short Description',
    cancel: 'Cancel',
    rounding: 'Rounding',
    empty_title: 'No price formula yet',
    empty_msg: 'You dont have price formula yet',
    error_add_variable: 'Please use the variable or constant',
    error_add_operator: 'Please use the operator',
    error_no_close: 'Please close the brackets',
    error_use_formula: 'This variable is used in the formula',
    error_close_bracket: 'Invalid close bracket',
    error_number_of_variable: 'Please use at least 2 variables or constant',
    error_get_global: 'Failed to fetch Global Variable data',
    error_get_formula: 'Failed to fetch Formula Variable data',
    error_get_product: 'Failed to fetch Product Variable data',
    formula_label: 'Formula',
    save_success: 'Price Formula has been saved.',
    save_failed: 'Failed to save Price Formula',
  },
  price_setting: {
    label_variable: 'Variable Name',
    label_value: 'Value',
    label_formula: 'Formula Name',
    label_description: 'Short Description',
    error_variable_name: 'Variable name should not be empty',
    error_max_variable_name: 'Variable name can only be 30 characters',
    error_variable_name_pattern:
      'Variable name can only be alphanumeric & underscore',
    error_max_formula: 'Formula name can only be 30 characters',
    error_formula_pattern:
      'The formula name can only be alphanumeric & underscore',
    error_formula_name: 'Formula name should not be empty',
    error_value_empty: 'Value should not be empty',
    error_description: 'Short Description should not be empty',
    error_formula_same: 'Variable cannot be more than 1 ',
    error_formula_empty: 'Formula should not be empty',
    confirm_delete_msg: 'Are you sure you want to delete {type}',
    confirm_delete_info: '{type} will not reappear in the list',
    success_delete_msg: '{name} successfully deleted',
    cant_delete: 'Cannot Delete',
    used_msg: 'used in following {type}',
  },
  price_area_page: {
    add_title: 'Add Price per Area',
    name_label: 'Price per Area Name',
    name_placeholder: 'Price Area',
    province_label: 'Province',
    province_placeholder: 'Search Province',
    province_select_all: 'Select All Province',
    city_label: 'City / Regency',
    city_placeholder: 'Search City',
    city_select_all: 'Select All City',
    district_label: 'District',
    district_placeholder: 'Search District',
    district_select_all: 'Select All District',
    submit: 'Submit',
    validation_area: 'Area must be filled',
    success_add: 'Price Area Data Successfully Added',
    error_save: 'Oops, inventory Price Area Failed to save',
    change_data: 'Change Data',
    coverage_area: 'Coverage Area',
  },
  no_valid: {
    required: 'should not be empty',
    alphanum_underscore: 'Can only be alphanumeric & underscore',
  },

  userManage: {
    search: 'Search',
    add_user: 'Add User',
    user_management: 'User Management',
    filter: 'Filter',
    username: 'Username',
    full_name: 'Full Name',
    role: 'Role',
    email: 'Email',
    phone_number: 'Phone Number',
    created_at: 'Created',
    business: 'Business',
    warehouse: 'Warehouse',
    delete: 'Delete',
    empty_title: 'No Users',
    empty_desc: 'Currently you <br /> do not have any user data',
    add_user_button: 'Add User',
    status: {
      invited: 'Invited',
      inactive: 'Inactive',
      active: 'Active',
    },
    actions: {
      deactivate: 'Deactivate',
      activate: 'Activate',
    },
    messages: {
      update_success: 'Data successfully updated',
      delete_success: 'Data successfully deleted',
      invite_success_title: 'Success',
      invite_success_desc: 'You have successfully added a new user',
      invite_success_done: 'Done',
    },
    add_new_user: 'Add New User',
    user_role: 'User Role',
    name: 'Name',
    password: 'Password',
    phone: 'Phone',
    phone_number_placeholder: 'phone number',
    send_password_to_email: 'Send Password to Email',
    ask_password_change: 'Ask for a password changing in the next Sign-in',
    add_warehouse_location: 'Add Warehouse Location',
    status_label: 'Status',
    new_user: 'New User',
    user_information: 'User Information',
    mobile_number: 'Mobile Number',
    full_name_label: 'Full Name',
    select_role: 'Select Role',
    working_area: 'Working Area',
    access_list: 'Access List',
    edit_user: 'Edit User',
    cancel: 'Cancel',
    save: 'Save',
    apply: 'Apply',
    clear_filter: 'Clear filter',
    clear_selection: 'Clear Selection',
    items_selected: '{count} items selected',
    select_all: 'Select All {label}',
    confirm_msg_edit: 'Are you sure you want to change the user data?',
    confirm_msg_delete: 'After deleting User Management from the list, this data will be deleted immediately',
    confirm_title: 'Confirmation',
    confirm_delete_title: 'Are you sure you want to delete?',
    history_title: 'Change History',
    success_title: 'Success',
    submit_edit: 'Yes, Edit User',
    submit_delete: 'Confirm',
    back_to_dashboard: 'Back To Dashboard',
    change_password_msg: 'Are you sure?',
    password_changed_msg: 'Password successfully changed',
    submit_change_password: 'Yes, Change Password',
    validations: {
      email_required: 'Email cannot be empty',
      phone_required: 'Phone Number cannot be empty',
      role_required: 'Role cannot be empty',
      business_required: 'Business cannot be empty',
      warehouse_required: 'Warehouse cannot be empty',
      full_name_required: 'Full name cannot be empty',
    },
  },
  validations: {
    ...validation.messages,
    no_space: '{_field_} should not contain space',
    not_greater_than: 'Unit must be greater than conversion',
    not_less_than: 'Unit must be greater than conversion',
  },
  businessClient: {
    client: 'Client',
    add_client: 'Add Client',
    edit_client: 'Edit Client',
    detail_client: 'Detail Client',
    id_business_user: 'ID Business or Username',
    information: 'Information',
    currency: 'Currency',
    category: 'Business Category',
    business_identity: 'Business Identity',
    business_name: 'Business Name',
    company_information: 'Company Information',
    company_name: 'Company Name',
    tax_liability: 'Tax Liability',
    company_address: 'Company Address',
    warehouse: 'Warehouse',
    contact: 'Contact',
  },
  store_list_page: {
    undefined: '-',
    store_list: 'Store List',
    product_confirm: 'Product Confirm',
    confirmed: 'Confirmed',
    unconfirmed: 'Unconfirmed',
    part_confirmed: 'Part Confirmed',
    mix_confirmed: 'Mix Confirmed',
    active: 'Active',
    not_active: 'Inactive',
    inactive: 'Inactive',
    store_code: 'Store Code',
    store_id: 'Store ID',
    store_name: 'Store Name',
    sales_channel: 'Sales Channel',
    store_status: 'Store Status',
    api_password: 'API Seller Key',
    auto_confirm: 'Auto Confirm',
    auto_accept_order: 'Auto Accept Order',
    authorization_time: 'Authorization Time',
    country: 'Country',
    channel: 'Channel',
    action: 'Action',
    store_products: 'Product Name',
    voucher_type: 'Voucher Type',
    voucher_name: 'Voucher Name',
    periode: 'Period',
    kuota: 'Quota',
    status: 'Status',
    variant: 'Variant',
    variant_count: 'Number of variants',
    description: 'Description',
    product_catalog_mapping: 'Product Catalog Mapping',
    select_product: 'Select Product',
    empty_title: 'No product data yet',
    empty_msg: 'You dont have product data yet',
    search_placeholder: 'Search store or sales channel',
    add_store: 'Add Store',
    connected: 'Connect',
    disconnected: 'Disconnected',
    status: 'Status',
    all_channel: 'All Channels',
    all_status: 'All Status',
    all_country: 'All Countries',
    all: 'All',
    product: 'Product',
    change_product: 'Detail Product',
    change_data: 'Change Data',
    deactivate_product: 'Deactivate Product',
    activate_product: 'Activate Product',
    search_products: 'Search Products Name / SKU',
    product_name: 'Product Name',
    channel_products_catalog: 'Channel Products Catalog',
    see_more: 'See More',
    modal_info: 'If the product is not in the master product, add a product',
    modal_empty_msg: 'Product not in product master',
    categories: 'Categories',
    range_price: 'Price Range',
    blibli_sku: 'Blibli SKU',
    program_name: 'Program Name',
    voucher_name: 'Voucher Name',
    voucher_type: 'Voucher Code & Type',
    discount_rank: 'Discount Rate',
    program_type: 'Program Type',
    periode: 'Period',
    kuota: 'Quota',
    live: 'Active',
    activate: 'Active',
    seller_deactivated: 'Not Active',
    seller_delete: 'Seller Delete',
    deactivated: 'Not Active',
    draft: 'Draft',
    active: 'Active',
    notActive: 'Not Active',
    not_active: 'Not Active',
    return: 'Active',
    return_release: 'Not Active',
    view_detail: 'View Detail',
    product_mapping: 'Product Mapping',
    product_status: 'Product Status',
    mapping_status: 'Mapping Status',
    rules: {
      store_name: 'Store Name is required',
      store_id: 'Store ID is required',
      client_id: 'Client ID is required',
      api_password: 'API Seller Key is required',
      client_secret: 'Client Secret is required',
      main_warehouse: 'Main warehouse must be selected',
      master_warehouse: 'Warehouse Master must be selected',
      channel_warehouse: 'Channel warehouse must be selected',
      arrange_shipment: 'Arrange Shipment must be selected',
    },
    status_label: {
      connected: 'Connected',
      disconnected: 'Disconnected',
      waiting: 'Waiting',
      pending_warehouse: 'Pending Warehouse',
      reauthentication_required: 'Reauthentication Required',
      token_expired: 'Token Expired',
    },
    actions: {
      approve: 'Approve',
      deactivate: 'Deactivate',
      activate: 'Activate',
      disconnect: 'Disconnect',
      mapping_warehouse: 'Mapping Warehouse',
      edit_mapping_warehouse: 'Edit Mapping Warehouse',
      reconnect: 'Reconnect',
      reauthorize: 'Reauthorize',
      cancel: 'Cancel',
      confirm: 'Confirm',
      bind_now: 'Bind Now',
      agree: 'Agree',
      activate_auto_accept: 'Activate Auto Accept Order',
      deactivate_auto_accept: 'Deactivate Auto Accept Order',
    },
    messages: {
      reauthorize_success_title: 'Reauthorize Success',
      reauthorize_success_desc: 'Shopee channel has been reauthorized successfully.',
      reauthorize_failed_title: 'Reauthorize Failed',
    },
    detail: {
      title: 'Store Detail',
      channel_id: 'Channel ID',
      warehouse: 'Warehouse',
      warehouse_channel: 'Warehouse Channel',
      warehouse_master: 'Warehouse Master',
      arrange_shipment: 'Arrange Shipment',
      auto_receive: 'Auto Receive Order',
      last_updated: 'Last updated:',
      binding_done: 'You have done Binding',
      read_terms: 'Read the following terms:',
      terms_checkbox: 'I have read and understood the terms of Tokopedia x TikTok Shop binding',
      binding_terms: {
        1: 'Make sure you have previously done binding on Tokopedia seller centre',
        2: 'You cannot unbind if the binding process has been done',
        3: 'Make sure you select the same Tokopedia channel when binding in your Tokopedia seller centre',
        4: 'During the binding process you will be asked to login to TikTok account again.',
        5: 'Make sure you login to the intended TikTok account and the one that has been bound to Tokopedia seller centre',
        6: 'Any mistakes in selecting Tokopedia & TikTok accounts during this binding process are your full responsibility.',
        7: 'If you are sure, please click the "Bind Now" button',
      },
    },
    integration: {
      approve_title: 'Approve Tokopedia Integration',
      desc_1: 'To approve integration for store [{storeName}], create sure the store status is active in Tokopedia dev console:',
      desc_path: 'dev console > app management > select live apps > shop management',
      desc_2: 'Enter Tokopedia App ID from live apps used to register store [{storeName}] as in Tokopedia dev console.',
      desc_3: 'Input shop ID from store [{storeName}] in the following field',
      enter_app_id: 'Enter App ID',
      enter_shop_id: 'Enter Shop ID',
    },
    auto_accept: {
      confirm_title: 'Are you sure you want to {action} auto accept on this channel?',
      confirm_ok: 'Yes, {action}',
      change_arrange_shipment: 'Change Arrange Shipment',
      change_auto_accept: 'Change Auto Accept',
      update_arrange_shipment: 'Update Arrange Shipment',
      select_shipment: 'Select arrange shipment update',
      info_message: 'Orders entering powerbiz will be automatically accepted by the system, but shipment arrangement is not set on {channelName}, please select one of the processes below for powerbiz system to update shipment arrangement on {channelName}',
      this_channel: 'this channel',
      status_success: 'Success',
      status_failed: 'Failed',
      activate: 'Activate',
      deactivate: 'Deactivate',
      update_auto_accept_success: 'Change Auto Accept Order Success',
      update_auto_accept_failed: 'Change Auto Accept Order Failed',
      deactivate_store_process: 'Deactivate store process {status}',
      error_save_inventory: 'Oops, failed to save product inventory',
      sort: {
        alphabetical: 'Alphabetical',
        numerical: 'Numerical',
      },
      shipment_label: {
        allocated: 'Allocated Stock',
        picking: 'Picking',
      },
      shipment_tooltip: {
        allocated: 'Allocated stock: shipment arrangement on {channel} will be set when stock is allocated',
        picking: 'Picking: shipment arrangement on {channel} will be set when items have been picked from the warehouse shelf',
      },
    },
    disconnect_warning: {
      confirm_msg: 'Are you sure you want to disconnect your Blibli store - <b>{storeName}</b> from POWERBIZ application?',
      success_msg: 'Your Blibli store - <b>{storeName}</b> has been successfully disconnected from POWERBIZ application',
    },
    mapping_modal: {
      title: 'Edit Warehouse Mapping {channelName} - {storeName}',
      title_main: 'Warehouse Mapping',
      table: {
        channel_warehouse: 'Channel Warehouse',
        master_warehouse: 'Master Warehouse',
        status: 'Status',
        action: 'Action',
        no_data: 'No Data',
        select_master_placeholder: 'Select Master Warehouse',
        not_connected_label: 'No connected warehouse yet',
        not_connected_tag: 'Not Connected',
        connected_tag: 'Connected',
      },
      tooltips: {
        add_sync: 'Add Warehouse Synchronization',
        disconnect_sync: 'Disconnect Warehouse Synchronization',
        save_sync: 'Save & Synchronize Warehouse',
        cancel: 'Cancel',
      },
      confirm: {
        disconnect_title: 'Are you sure you want to disconnect warehouse synchronization?',
        disconnect_ok: 'Yes, disconnect synchronization',
        disconnect_cancel: 'No',
      },
      messages: {
        duplicate_warehouse: 'The warehouse you selected is already connected to another channel',
        master_required: 'Master warehouse not selected',
        channel_code_missing: 'Failed to synchronize warehouse, channel code not found',
        success_add: 'Successfully added warehouse synchronization',
        success_disconnect: 'Successfully disconnected warehouse synchronization',
        success_sync: 'Successfully synchronized warehouse',
        warehouse_not_found: 'Failed to synchronize warehouse, warehouse not found',
        coming_soon: 'Coming Soon',
        please_wait: 'Please wait...',
        error_occurred: 'Error occurred',
        action_not_available: 'Failed to perform warehouse mapping action because this action is not yet available',
        disconnect_code_missing: 'Failed to disconnect warehouse synchronization, channel code not found',
        success_update: 'Successfully updated warehouse synchronization',
        channel_status_not_updated: 'The store status has not been updated by the server. Please try again shortly.',
        warehouse_already_connected: 'The warehouse you selected is already connected to another channel',
        master_not_selected: 'Master warehouse not selected',
        failed_not_found: 'Failed to synchronize warehouse, warehouse not found',
        success_add_sync: 'Successfully added warehouse synchronization',
        success_disconnect_sync: 'Successfully disconnected warehouse synchronization',
        failed_sync_warehouse_not_found: 'Failed to synchronize warehouse, warehouse not found',
        master_warehouse_not_selected: 'Master warehouse not selected',
      },
    },
    synchronize: {
      sort: {
        alphabetical: 'Alphabetical',
        numerical: 'Numerical',
      },
      filter_status_product: 'Filter Product Status',
      sort_status_asc: 'Status Asc',
      sort_status_desc: 'Status Desc',
      sync_product: 'Sync Product',
      sync_all_product: 'Sync All Product',
      sync_process_running: 'Sync process running',
      sync_info_title: 'Sync Information',
      sync_running_msg: 'Product sync process is running.',
      sync_started_at: 'Sync started at',
      last_sync_info: 'Last Sync Information',
      sync_success: 'Success',
      sync_failed: 'Failed',
      sync_desc_part1: 'performing product sync, on',
      sync_desc_part2: 'until',
      history_update_stock: 'History Update Stock',
      selected_product: 'Selected Product:',
      create_master_product: 'Create Master Product',
      sync_stock: 'Sync Stock',
      deactivate_product_title: 'Deactivate Product',
      activate_product_title: 'Activate Product',
      confirm_desc_part1: 'Are you sure you want to',
      deactivate: 'deactivate',
      activate: 'activate',
      confirm_desc_part2: 'product:',
      this: 'this',
      cancel: 'Cancel',
      yes: 'Yes',
      warehouse_required_msg: 'Warehouse must be selected',
      select_warehouse: 'Select Warehouse',
      master_warehouse: 'Master Warehouse',
      channel_warehouse: 'Channel Warehouse',
      sync_single_product: 'Sync Single Product',
      sync_single_product_process: 'Product is being synchronized.',
      sync_single_product_success: 'Product Successfully Synchronized',
      sync_single_product_error: 'An Error Occurred',
      sync_single_product_error_desc: 'Failed to synchronize product',
      loading_info: 'Loading mapping and warehouse stock information...',
      synced: 'Synced',
      not_synced: 'Not Synced',
      info_mapping_stock: 'Mapping and Warehouse Stock Information',
      no_reserved_stock_info: 'this channel has no reserved stock info',
      cant_sync_stock_msg: 'Cannot sync stock because product status is not yet synced',
      info_history_product_warehouse_channel: 'Channel Warehouse Product History Information',
      hide_raw_data: 'Hide RAW Data',
      show_raw_data: 'View RAW Data',
      no_history_stock_info: 'this channel has no stock history info',
      no_info_mapping_stock: 'No mapping and warehouse stock information',
      master_stock: 'Master Stock',
      checking_import_status: 'Checking import status...',
      import_product_success: 'Product successfully imported to Master',
      import_product_failed: 'Failed to import product, please try again.',
      import_product_failed_title: 'Failed to Import Product',
      some_products_import_failed: 'Some products failed to import',
      check_import_status_failed: 'Failed to check import status',
      channel_stock: 'Channel Stock',
      allocation: 'Allocation',
      action: 'Action',
      product_not_synced_warehouse_master: 'this product is not yet synced with master warehouse',
      no_warehouse_connected: 'no warehouse connected',
    },
    product_master_modal: {
      not_mapped: '(Not Mapped)',
      remove_mapping: 'Remove Mapping',
      mapping_product: 'Mapping Product',
      master_product_catalog: 'Master Product Catalog',
      choose_product: 'Choose Product',
      confirm_remove_mapping: 'Are you sure you want to remove this product mapping?',
      success_remove_mapping: 'Product mapping successfully removed',
      success_mapping: 'Product successfully mapped',
      failed_mapping: 'Failed to Map Product',
      channel_catalog_name: 'Channel Catalog Name',
      channel_catalog_sku: 'Channel Catalog SKU',
      master_catalog_name: 'Master Catalog Name',
      master_catalog_sku: 'Master Catalog SKU',
    },
    sync_blibli_sku: {
      title: 'Sync Product Blibli by SKU',
      enter_sku: 'Enter product SKU',
      powerbiz_sku: 'Powerbiz SKU: ',
      blibli_sku: 'Blibli SKU: ',
    },
    upload_master: {
      info_msg: 'You can import 10,000 data at once (format: xlsx,xls) to update Price in bulk.',
      download_template: 'Download Template',
      row_selected: 'row selected',
      upload_template: 'Upload Template',
      upload_file: 'Upload File',
      file_type_error: 'Please upload xls / xlsx file',
      upload_success: 'Template uploaded successfully',
      select_rows_error: 'Please select rows',
      min_max_rows: 'minimum 1, maximum 10',
    },
    deleted: 'Deleted',
    disconnect_modal: {
      shopee_info: 'For now, please contact the Powerbiz team to disconnect your Shopee channel.',
      close: 'Close',
      confirm_title: 'Are you sure you want to disconnect your store from powerbiz?',
      cancel: 'Cancel',
      confirm: 'Yes, Disconnect Store',
    },
    create_product_modal: {
      title: 'Add {channel} Product',
      redeem: 'Redeem',
      shopee: 'Shopee',
      toco: 'Toco',
      tokopedia: 'Tokopedia',
      distributorship: 'Distributorship',
      desc_redeem: 'You can create a new Redeem product.',
      desc_master: 'You can create {channel} products from existing master products or create new products.',
      create_new: 'Create New Product',
      use_existing: 'Use Existing Product',
      select_product: 'Select Product',
      draft_confirm: {
        title: 'You have a product draft',
        desc: 'To create a new product you can continue with the draft or create a new one',
        continue_draft: 'Continue Draft',
        delete_draft: 'Delete Draft and Create New',
        next: 'Next',
      },
    },
  },
  export_history_page: {
    title: 'Export History',
    total_caption: 'Total All Orders {total}',
    date: 'Export Date',
    user: 'User',
    menu: 'Menu',
    file_export: 'File Export',
    status: 'Status',
    date_completed: 'Completed Date',
    try_again: 'Try again',
    empty_title: 'No data',
    empty_msg: "You don't have any data yet",
    no_file: "Your file is being generated. Please wait…",
    all: 'All',
    finished: 'Finished',
    on_progress: 'On Progress',
    failed: 'Failed',
    sales: 'Sales',
    download_hint: 'Click here to download',
    details: 'Details',
    action: 'Action',
    redirect_message: 'After clicking Export Excel, you’ll be redirected to the Export History page.',
    shopee_warning: 'For Shopee, data is only available for the last 90 days..',
    toco_warning: 'For Toco, data is only available for the last 90 days..',
    business: 'Business',
    currency: 'Currency',
    sales_periode: 'Sales Periode',
    detail_export: 'Detail Export Excel',
    info: "Info",
    warehouse: "Warehouse",
    sales_channel: "Sales Channel",
    channel: "Toko",
    parameters: 'Parameters & Filters',
    workspace: "Workspace",
    generating: 'Generating file...',
    detail_export_subtitle: 'Excel export request details',
    max_order_message: "Export limit exceeded",
    max_order_description: "Please refine your filters so the total rows are {limit} or fewer.",
  },
  exportSales: {
    tooltip_simple: 'Export all order data without additional filters.',
    tour_advance_title: 'Advance Mode',
    tour_advance_content: 'Currently, the Advance export mode only supports filtering for Tiktok sales channel.',
    info_mode_version_2: 'info Mode Version 2.0',
    info_mode_version_2_desc_1: 'Table name adjustment',
    info_mode_version_2_desc_2: 'Addition of transaction discount data for seller & seller items, voucher for seller & platform items, shipping discount for seller & platform, customer payment',
    info_mode_version_2_desc_3: 'Currently version 2.0 is only available for Tiktok',
  },
  supplier: {
    title: 'Manage Supplier',
    add_supplier: 'Add Supplier',
    search_placeholder: 'Search Supplier...',
    sort_name_asc: 'Supplier Name, A-Z',
    sort_name_desc: 'Supplier Name, Z-A',
    columns: {
      code: 'Supplier Code',
      name: 'Supplier Name',
      address: 'Address',
      email: 'Email',
      phone: 'Phone',
    },
    add_title: 'Add Supplier',
    creating_tip: 'Creating supplier, please wait...',
    form: {
      code: 'Supplier Code',
      name: 'Supplier Name',
      city: 'City',
      address: 'Address',
      email: 'Email',
      phone: 'Phone Number',
    },
    placeholder: {
      code: 'Enter supplier code',
      name: 'Enter supplier name',
      city: 'Enter City',
      address: 'Enter Address',
      email: 'Enter Email',
      phone: 'Enter Phone Number',
    },
    success_add: 'Successfully added supplier',
    error_add: 'Failed to add supplier',
    error_business_id: 'Failed to add supplier, business_id not found',
    rules: {
      required: '{fieldName} is required',
      max: '{fieldName} maximum {max} characters',
    },
  },
  inventory: {
    productName: 'Product Name',
    inventory: 'Inventory - Client',
    firstPeriod: 'First Period',
    initialStock: 'Initial Stock',
    lastPeriod: 'Last Period',
    lastStock: 'Last Stock',
    baseUOM: 'Base UoM',
    date: 'Date',
    changeType: 'Change Type',
    changeStock: 'Change Stock',
    period: 'Period',
    stock_movement: {
      filter_by: 'Filter By',
      search_placeholder: 'Search Product Name or No SKU',
      choose_product: 'Choose Product Name',
      choose_change_type: 'Choose Change Type',
      types: {
        inbound: 'Inbound',
        cancel_inbound: 'Cancel Inbound',
        purchase_return: 'Purchase Return',
        cancel_order: 'Cancel Order',
        sales_return: 'Sales Return',
        outbound: 'Outbound / Goods Issue',
        adjust_in: 'Adjust In',
        adjust_out: 'Adjust Out',
      },
    },
    goods_receipt: {
      create_title: 'Create Goods Receipt',
      create_desc: 'You can create a Goods Receipt based on a Reference Document (PO, etc.) that has been created or without a Reference Document.',
      without_ref: 'Without Reference Document',
      use_po_ref: 'Use PO Reference Document',
      placeholder_po: 'Enter PO Number',
      tooltip_disabled: 'PO already fully received or canceled',
      btn_create: 'Create GR',
      product: 'Product',
      qty: 'Quantity',
      uom: 'UoM',
      base_info: 'Base Info',
      base_qty: 'Base Quantity',
      base_uom: 'Base UoM',
      stock_on_hand: 'Stock On Hand',
      stock_change: 'Stock Change',
      stock_after: 'Stock After Change',
      detail_gr: 'Detail Goods Receipt',
      no_gr: 'No. Goods Receipt',
      gr_date: 'GR Date',
      doc_ref: 'Document Reference Number',
      vendor_name: 'Vendor Name',
      detail_item: 'Product Item Detail',
      add_item: 'Add Item',
      bulk_import: 'Bulk Item Import',
      total_sku: 'Total SKU',
      qty_po: 'Qty Inbound Delivery',
      reference_detail: 'Reference Detail',
      gr_detail: 'GR Detail',
      qty_ref_max: 'Qty Ref Max',
      uom_ref_max: 'UOM Ref Max',
      qty_gr: 'Qty GR',
      uom_gr: 'UOM GR',
      qty_inbound: 'Qty Inbound Delivery',
      uom_inbound: 'UOM Ref',
      qty_outstanding: 'Qty Outstanding',
      uom_outstanding: 'UOM Outstanding',
      max_qty: 'Max Qty',
      batch_no: 'Batch No.',
      expired_date: 'Expired Date',
      stock_type: 'Stock Type',
      po_ref_doc: 'PO Document Reference',
      warehouse: 'Warehouse',
      tooltip_cant_add: 'Cannot add new item if using PO document reference',
      error_max_item: 'Number of items exceeds the maximum limit, the maximum limit is {max} items',
      error_qty_empty: 'Quantity cannot be empty.',
      success_save: 'Data Successfully Saved',
      failed_save: 'Data Failed to Save, Please Try Again.',
      failed_save_title: 'Failed to create GR',
      note: 'Note',
      import_items: 'Import Items',
      upload_desc: 'Uploading file, {current}/{total} items have been imported',
      upload_placeholder: 'Upload your excel file here',
      upload_hint: 'If you do not have an import items template file, please click the download file button at the bottom left.',
      warning: 'Warning',
      error_bulk_limit: 'The number of imported items exceeds the maximum limit of {max} items. Please check your import file.',
      download_template: 'Download Template',
      submit_all: 'Submit All Items',
      list_revised: 'List Revised Imported Items',
      uploading: 'Uploading file...',
      sku_not_found: 'SKU not found',
      uom_not_valid: 'UoM not valid',
      data_not_valid: 'Data not valid',
      close_no_download: 'Close Without Download',
      close_download: 'Close and Download Revised List',
      stock_list: {
        available: 'Available',
        quarantine: 'Quarantine',
        damage: 'Damage',
        wip: 'Work In Progress',
      },
      columns: {
        no: 'No',
        product_name: 'Product Name',
        sku: 'SKU',
        quantity: 'Quantity',
        uom: 'UoM',
      },
    },
  },
  productAvailability: {
    search: 'Search',
    productName: 'Product Name',
    vendorName: 'Vendor Name',
    note: 'Note',
    productAvailability: 'Product Availability',
    goodsReceipt: 'Goods Receipt',
    gudang: 'Select Warehouse',
    inbound: 'Create Inbound',
    adjustment: 'Stock Adjustment',
    adjustmentType: 'Adjustment Type',
    allstatus: 'All Status',
    instock: 'In Stock',
    outofstock: 'Out of Stock',
    minusofstock: 'Minus Stock',
    movement: 'Movement History',
    location: 'location',
    available: 'Available',
    allocated: 'Allocated',
    grDate: 'GR Date',
    grAdjustment: 'Adjustment Date',
    warningGr: 'Select Warehouse To Make Goods Receipt',
    warningReturn: 'Select Warehouse To Make Return Received',
    warningAdjustment: 'Select Warehouse To Make Stock Adjustment',
    reference: 'Document Reference Number',
    adjustmentNumber: 'Adjustment Number',
    warehouseName: 'Warehouse Name',
    warehouseStock: 'Warehouse Stock',
    inorder: 'On Order',
    safetyStock: 'Safety Stock',
    title: 'Product Name',
    sku: 'SKU',
    warehouseId: 'Warehouse Name',
    businessName: 'Business Name',
    availability: 'Available Stock',
    allocatable: 'Allocatable Stock',
    allocable: 'Allocable',
    movementQty: 'Movement Quantity',
    onHand: 'On Hand',
    inOrder: 'In Order Stock',
    unit: 'Unit',
    updatedAt: 'Date',
    IN_STOCK: 'In Stock',
    OUT_OF_STOCK: 'Out of Stock',
    MINUS_OF_STOCK: 'Minus Stock',
    warehouse: 'Warehouse',
    stock: 'Stock',
    unit_label: 'Unit',
    status: 'Status',
    movement_transaction: 'Transaction Movement',
    product_detail: 'Product Detail',
    hide_bundle_components: 'Hide Bundle Components',
    show_bundle_components: 'Show Bundle Components',
    soft_bundling_tooltip: 'Soft bundling products do not have on-hand stock. See product components to see stock details',
    soft_bundling_tooltip_order: 'Soft bundling products do not have on-order stock. See product components to see stock details',
    error_fetch_inventory: 'Failed to fetch inventory data',
    export_failed: 'Export Data Failed',
    export_failed_desc: 'Failed to export inventory data',
    soft_bundling: 'Soft Bundling',
    error_fetch_soft_bundling: 'Failed to fetch soft bundling data',
    export_excel: 'Export Excel',
    select_business: 'Select Business',
    select_warehouse: 'Select Warehouse',
    select_status: 'Select Stock Status',
    details: 'Details',
    copy_success: '{value} successfully copied',
    stock_movement: 'Stock Movement',
    movement_type_select: 'Select Movement Type',
    enter_reff: 'Enter Reff',
    sellable_stock: 'Sellable Stock',
    sellable_stock_tooltip: 'Stock that can be sold and appears on sales channels',
    on_order_tooltip: 'Order stock in process, before good issued',
    on_hand_tooltip: 'Stock with available status (includes sellable and on order stock)',
    reserved_stock_tooltip: 'Stock reserved for specific needs or orders in process',
    movement_quantity: 'Movement Quantity',
    transaction: 'Transaction',
    stock_movement_not_found: 'Stock movement data not found',
    no_data_filter: 'No data based on the selected filter.',
    total_data: 'Total Data',
    date_filter_label: 'Order Date',
    movement_type_label: 'Movement Type',
    movement_status: {
      all: 'All Transaction Types',
      good_receive: 'Good Receive',
      cancel_good_receive: 'Cancel Good Receive',
      good_issued: 'Good Issued',
      cancel_good_issued: 'Cancel Good Issued',
      adj_in: 'Adjustment In',
      adj_out: 'Adjustment Out',
      adj_booking: 'Adjustment Booking',
      booking_order: 'Booking Order',
      release_booking: 'Release Booking',
      transfer_in: 'Stock Transfer Warehouse In',
      transfer_out: 'Stock Transfer Warehouse Out',
      cancel_transfer_out: 'Cancel Transfer Out',
      type_transfer_in: 'Stock Type Transfer In',
      type_transfer_out: 'Stock Type Transfer Out',
      ptp_in: 'Product to Product Transfer In',
      ptp_out: 'Product to Product Transfer Out',
      vas_inbound: 'VAS Inbound',
      vas_outbound: 'VAS Outbound',
      return: 'Return',
      cancel_return: 'Cancel Return',
      reserved: 'Adjustment Reserved',
    },
    ranges: {
      today: 'Today',
      this_month: 'This Month',
      this_year: 'This Year',
      last_7_days: 'Last 7 Days',
      last_30_days: 'Last 30 Days',
      last_year: 'Last 1 Year',
    },
    unknown_warehouse: '-[UNKNOWN WAREHOUSE]-',
    allocation_saved: 'Stock Allocation successfully saved',
    enable_stock_push: 'Enable stock push',
    allocation: 'Allocation',
    channel: 'Channel',
    deleted_channel: '(deleted channel)',
    stock_push_disabled_sku: 'Stock push disabled for this SKU',
    stock_push_enabled: 'Stock push: Enabled',
    stock_push_disabled: 'Stock push: Disabled',
    stock_push_label: 'Stock push',
    on_hand_stock: 'On Hand',
    allocated_stock: 'Allocated stock',
    sellable_stock_short: 'Sellable stock',
    allocation_history_tab: 'History',
    allocation_history_date: 'Date',
    start_date: 'Start Date',
    end_date: 'End Date',
    pagination_total: 'Showing {start} - {end} of {total} items',
    allocation_history_scope: 'Scope',
    allocation_history_channel: 'Channel',
    allocation_history_prev_status: 'Previous Status',
    allocation_history_new_status: 'New Status',
    allocation_history_user: 'Changed By',
    allocation_history_enabled: 'Enabled',
    allocation_history_disabled: 'Disabled',
    allocation_history_empty: 'No history yet',
    allocation_history_error: 'Failed to load history',
    allocation_history_warehouse: 'Warehouse',
    allocation_history_channel_scope: 'Per Channel',
    allocation_history_warehouse_scope: 'Per Warehouse',
    allocation_tab: 'Stock Allocation',
    allocation_history_select_catalog: 'Select a variant to view history',
    allocation_history_select_warehouse: 'Select a warehouse to view history',
    grNumber: 'GR No.',
    createGr: 'Create GR',
    importGr: 'Import GR',
    detailGr: 'Detail GR',
    uploadBulkGr: 'Upload Bulk GR',
    bulkGrSummary: 'Bulk GR Upload Summary',
    downloadFailedData: 'Download Failed Data',
    bulkImportGrDesc: 'Use this template to perform bulk goods receipt. Make sure the format is correct before uploading.',
    reserved_stock: 'Reserved',
    reserved_stock_tooltip: 'Stock reserved and cannot be sold',
    edit_reserved_stock: 'Edit Reserved',
    reserved_stock_history: 'Reserved History',
    reserved_stock_updated: 'Reserved stock updated successfully',
    tour_reserved_header_title: 'Reserved Column',
    tour_reserved_header_content: 'View reserved stock that is not available for sale',
    tour_reserved_edit_title: 'Manual Editing',
    tour_reserved_edit_content: 'Click the pencil icon to edit reserved stock',
    tour_bulk_reserved_title: 'Bulk Update Reserved Stock',
    tour_bulk_reserved_content: 'Use the Bulk Edit feature to update multiple reserved stock entries at once via Excel',
    tour_paham: 'Got it',
    reserved_stock_update_failed: 'Failed to update Reserved',
    reserved_stock_reason: 'Reason for change',
    reserved_stock_reason_placeholder: 'Enter reason for changing reserved',
    reserved_stock_reason_required: 'Reason is required',
    reserved_stock_reason_max_chars: 'Maximum 200 characters',
    reserved_stock_exceed: 'Reserved cannot exceed Available Stock',
    reserved_stock_negative: 'Reserved must be 0 or greater',
    reserved_stock_max_digits: 'Maximum 12 digits',
    reserved_stock_preview: 'Available Stock after change',
    reserved_stock_current: 'Current Reserved',
    reserved_stock_new_value: 'New Reserved',
    reserved_stock_previous: 'Previous Value',
    reserved_stock_new: 'New Value',
    reserved_stock_changed_by: 'Changed By',
    reserved_stock_no_history: 'No history yet',
    reserved_stock_quantity: 'Total Change',
    reserved_stock_date: 'Date',
    reserved_stock_movement_type: 'Type',
    reserved_in: 'Reserved In',
    reserved_out: 'Reserved Out',
    reserved_stock_from_upload: 'From Upload',
    reserved_stock_download_file: 'Download File',
  },
  reservedStock: {
    bulk_edit_reserved_stock: 'Bulk Edit Reserved Stock',
    upload_tab: 'Upload',
    history_tab: 'History',
    download_template_title: '1. Download Template',
    download_template_desc: 'Download the excel template file to fill in the reserved stock data to be imported.',
    upload_file_title: '2. Upload File',
    upload_excel_hint: 'Click or drag file to this area to upload',
    upload_excel_limit_hint: 'Support for a single upload. Please use the provided template.',
    download_template: 'Download Template',
    uploading: 'Uploading...',
    start_import: 'Start Import',
    processing: 'Processing...',
    import_failed: 'Import Failed',
    import_successful: 'Import Successful',
    total_rows: 'Total Rows',
    success_count: 'Success',
    failed_count: 'Failed',
    download_result_file: 'Download Result File',
    error_details_count: 'Error Details ({count} rows)',
    error_table_row: 'Row',
    error_table_sku: 'SKU',
    error_table_message: 'Error Message',
    history_table_col_info: 'Batch Info / SKU & Product Name',
    history_table_col_detail: 'Progress Detail / Remarks',
    history_table_col_action: 'Action',
    loading_history: 'Loading history...',
    download_template_error: 'Failed to download template.',
    upload_success_processing: 'File uploaded successfully. Processing...',
    upload_error_title: 'Upload Error',
    upload_error_failed: 'Failed to upload file',
    import_process_errors: 'The upload process encountered errors.',
    import_completed_success: 'Successfully processed {count} rows.',
    batch_detail_title: 'Reserved Stock Batch Detail',
    upload_time: 'Upload Time',
    user: 'User',
    batch_status: 'Batch Status',
    download: 'Download',
    sku_product: 'SKU / Product',
    warehouse: 'Warehouse',
    value: 'Value',
    reason_msg: 'Reason / Message',
    status: 'Status',
    copy_sku: 'Copy SKU',
    copied: 'Copied!',
    copied_desc: 'SKU {sku} copied to clipboard',
    search_placeholder: 'SKU / Product Name',
  },
  returnReceived: {
    title: 'Return Received',
    createReturn: 'Create Return Received',
    detailReturn: 'Detail Return Received',
    cancelReturn: 'Cancel Return Received',
    cancelConfirmTitle: 'Cancel Return Received',
    cancelConfirmContent: 'Are you sure you want to cancel Return Received with no. {number}?',
    cancelSuccess: 'Return Received successfully canceled',
    cancelFailed: 'Failed to cancel Return Received',
    returnNumber: 'Return Received No.',
    returnDate: 'Return Received Date',
    searchPlaceholder: 'Search Return No / Order No',
    detailCard: 'Return Received Detail',
    itemCard: 'Product Item Detail',
    totalSku: 'Total SKU',
    stockType: 'Stock Type',
    storeLabel: 'Store',
    refDocRequired: 'Reference Document must be selected',
    warehouseRequired: 'Warehouse must be selected',
    returnNoRequired: 'Return Received No. must be filled',
    status_return: 'Received',
    status_return_release: 'Cancelled',
  },
  account: {
    profile: 'Your Profile',
    fullname: 'Full Name',
    noHp: 'Phone Number',
    setPassword: 'Use a Strong Passwords',
    setting: 'Account Settings',
    password: 'Change Password',
    placeholder: {
      current_password: 'Current Password',
      new_password: 'New Password',
      confirm_new_password: 'Confirm New Password',
    },
    validation: {
      password_mismatch: 'Passwords do not match',
      current_password_required: 'Current password cannot be empty',
      new_password_required: 'New password cannot be empty',
      confirm_password_required: 'Confirm new password cannot be empty',
      email_required: 'Email is required',
      username_required: 'Username is required',
      fullname_required: 'Fullname is required',
      phone_required: 'Phone number is required',
    },
    messages: {
      update_success: 'Data successfully updated',
      password_changed: 'Password successfully changed',
    },
  },
  warehouse: {
    list_warehouse: 'List Warehouse',
    export_data: 'Export Data',
    add_warehouse: 'Add Warehouse',
    detail_warehouse: 'Detail Warehouse',
    edit_warehouse: 'Edit Warehouse',
    name_warehouse: 'Warehouse Name',
    ext_code: 'External Code',
    code_warehouse: 'Warehouse Code',
    search: 'Search',
    placeholder_search: 'Search...',
    category_warehouse: 'Category Warehouse',
    address: 'Address',
    status: 'Status',
    action: 'Action',
    information_warehouse: 'Warehouse Information',
    address_warehouse: 'Warehouse Address',
    integration_warehouse: 'Warehouse Integration',
    connected_with: 'Connected with',
    update_warehouse: 'Update Warehouse',
    editWarehouseData: 'Edit Warehouse Data',
    manageProducts: 'Manage Products',
    warehouseName: 'Warehouse Name',
    warehouseCode: 'Warehouse Code',
    externalCode: 'External Code',
    warehousePIC: 'Warehouse PIC',
    phoneNumber: 'Phone Number',
    country: 'Country',
    city: 'City',
    subDistrict: 'Sub District',
    postalCode: 'Postal Code',
    province: 'Province',
    district: 'District',
    please_select_city: 'Please Select City',
    not_connected_wms: 'Not Connected to Warehouse Management System',
    connected_javelin: 'Connected with Javelin',
    connected_jubelio: 'Connected with Jubelio',
    auth_key: 'Auth Key',
    secret_key: 'Secret Key',
    api_url: 'API URL',
    username: 'Username',
    password: 'Password',
    success_save: 'Data Successfully Saved',
    validation: {
      name_required: 'Warehouse Name Cannot Be Empty',
      name_exist: 'Warehouse Name already exists',
      code_required: 'Warehouse Code Cannot Be Empty',
      code_exist: 'Warehouse Code is already in use',
      ext_code_required: 'External Code Cannot Be Empty',
      ext_code_exist: 'External Code is already in use',
      pic_required: 'PIC Cannot Be Empty',
      phone_required: 'Phone Number Cannot Be Empty',
      country_required: 'Country Cannot Be Empty',
      city_required: 'City Cannot Be Empty',
      district_required: 'District Cannot Be Empty',
      province_required: 'Province Cannot Be Empty',
      postal_code_required: 'Postal Code Cannot Be Empty',
      address_required: 'Address Cannot Be Empty',
      auth_key_required: 'Auth Key Cannot Be Empty',
      secret_key_required: 'Secret Key Cannot Be Empty',
      api_url_required: 'API URL Cannot Be Empty',
      username_required: 'Username Cannot Be Empty',
      password_required: 'Password Cannot Be Empty',
    },
    placeholder: {
      name: 'Warehouse name',
      code: 'Warehouse code',
      ext_code: 'External code',
      pic: 'PIC',
      phone: 'Phone No.',
      auth_key: 'Enter Auth Key',
      secret_key: 'Enter Secret Key',
      api_url: 'Enter API URL',
      username: 'Enter Username',
      password: 'Enter Password',
    },
    setup_product: {
      title: 'Setup Product',
      question: 'Do you want to register all your products to the warehouse: <b>{name}</b>?',
      this_warehouse: 'this',
      all_products: 'Yes, all products',
      some_products: 'No, only some products',
      or: 'Or',
      setup_later: 'Setup Later',
      setup_later_desc: 'You can setup products through the <b>Warehouse List &#8594; Setup Product</b> menu',
      btn_cancel: 'Cancel',
      btn_next: 'Next',
      success_add: 'Products successfully added',
      failed_title: 'Failed',
      failed_desc: 'An error occurred while adding products to the warehouse.',
      error_wh_not_found: 'Warehouse id not found',
    },
    streetAddress: 'Address',
    warehouseConnection: 'Warehouse Connection',
    notConnected: 'Not Connected',
  },
  discount: {
    confirmation: 'Confirmation',
    promo_cancellation: 'Promo Cancellation',
    activate_promo_description: 'By activating Promo <b>{promotion_name}</b>, the promo will be published and can be used according to the applicable period.',
    cancel_promo_description: 'By cancelling Promo <b>{promotion_name}</b>, the promo will be inactive and cannot be used.',
    choose_reason_to_cancel: 'Select a reason to cancel this promo:',
    reasons: {
      duplicate: 'Promo duplication with other promo',
      change_period: 'Want to change / stop the promo active period',
      less_benefit: 'Related promo is less useful',
      other: 'Other reasons',
    },
    discount: 'Discount',
    search: 'Search Discount',
    createDiscount: 'Create Discount',
    latest: 'Latest Data',
    program_name: 'Program Name',
    promotionName: 'Program Name',
    discount_level: 'Discount Level',
    period: 'Period',
    quota: 'Quota',
    status: 'Status',
    all: 'All',
    waiting_approval: 'Waiting for Approval',
    active: 'Active',
    not_active: 'Not Active',
    sort_by: 'Sort by',
    order_by: 'Order',
    newest: 'Newest',
    oldest: 'Oldest',
    basic_details: 'Basic Details',
    promotion_target: 'Promotion Target',
    setting_promotion: 'Setting Promotion',
    start_date: 'Start Date',
    end_date: 'End Date',
    promotion_type: 'Promotion Type',
    select_type: 'Select Promotion Type',
    select_level: 'Select Discount Level',
    national_program: 'National Program',
    local_program: 'Local Program',
    distributor_program: 'Distributor Program',
    program_type: 'Program Type',
    select_program: 'Select Program Type',
    product_type: 'Product Type',
    product_item: 'Product Item',
    select_item: 'Select Product Item',
    product_category: 'Product Category',
    product_brand: 'Product Brand',
    promotion_quota: 'Promotion Quota',
    program_buy: 'Program Type & Purchase',
    discount_format: 'Discount Format',
    promotion_value: 'Promotion Value',
    promotion: 'Promotion',
    products: 'Product',
    transaction: 'Transaction',
    purchase_range: 'Purchase Range',
    min_qty: 'Min. Qty',
    max_qty: 'Max. Qty',
    min_trx: 'Min. Transaction',
    max_trx: 'Max. Transaction',
    uom: 'UoM',
    promotion_format: 'Promotion Format',
    percentage: 'Percentage',
    currency: 'Currency',
    fixed: 'Amount',
    product: 'Extra Item',
    product_name: 'Product Name',
    discount_max: 'Discount Max. Value',
    add_promotion: 'Add Promotion',
    voucher: 'Voucher',
    edit: 'Edit Discount',
    coin: 'Coin',
    coin_value: 'Coin Value',
    msg_extra_product: 'Extra Item {qty} {uom} {catalog}',
    msg_percentage_discount: 'Percentage discount of {value}% with maximum discount of {currency} {max_value}',
    msg_fixed_discount: 'Amount of {currency} {max_value}',
    msg_base: 'Every purchase of at least {currency} {min} {uom} will get a promo in the form of {gifts}, the promo applies in multiples with a multiple value of {currency} {multiple} {uom} and the maximum multiple value is {currency} {max} {uom}',
    promo_cancellation: 'Promo Cancellation',
    cancellation_description:
      'By canceling the {value} Promo, the promo will be inactive and cannot be used',
    choose_cancellation: 'Choose a reason to cancel this promo',
    write_reason: 'Write other reasons here',
    inactive: 'Not Active',
    success_activate: 'Promo successfully activated',
    success_cancel: 'Promo successfully cancelled',
    failed_activate: 'Failed to activate promo',
    failed_cancel: 'Failed to cancel promo',
    createdAt: 'Created Date',
    promotion_criteria: 'Promotion Criteria',
    purchase_transaction: 'Total Purchase Transactions',
    purchase_quantity: 'Total Purchase Quantity',
    promo_type: 'Promo Criteria Type',
    select_promo_type: 'Select Promo Criteria Type',
    range_promo: 'Range',
    multiple_promo: 'Multiple',
    multiple_value: 'Multiple Value',
    approval_title: 'Discount & Voucher Approval',
    cancellation_reason: 'Cancellation Reason',
    add_tier: 'Add Tier',
    approve: 'Approve',
    cancel_promo: 'Cancel',
    gift: 'Gift',
    qty: 'Quantity',
    error_min_max: 'Min is greater than Max',
    error_max_min: 'Max is smaller than Min',
    search_select_product: 'Search & Select Product',
    search_select_item: 'Search & Select Item Product',
    max_discount: '(Max. {currency} {max})',
    extra_item: 'Extra Item {qty} {uom} {product}',
    percentage_discount_desc: 'Percentage discount of {value}% with a maximum discount of {currency} {max}',
    fixed_discount_desc: 'Nominal of {currency} {max}',
    promo_description: 'Each minimum purchase of {min} will get a promo in the form of {gifts}, the promo applies in multiples with a multiple value of {multiple} and the maximum multiple value is {max}',
    rules: {
      program_name_required: 'Program Name is required',
      start_date_required: 'Start Date must be selected',
      end_date_required: 'End Date must be selected',
      promotion_type_required: 'Promotion Type must be selected',
      discount_level_required: 'Discount Level must be selected',
      program_type_required: 'Program Type must be selected',
      promo_criteria_type_required: 'Promo Criteria Type must be selected',
      voucher_code_required: 'Voucher Code is required',
      uom_required: 'UoM must be selected',
      discount_format_required: 'Discount Format must be selected',
      currency_required: 'Currency must be selected',
      product_required: 'Product must be selected',
      input_required: 'Input is required',
      input_not_zero: 'Input cannot be 0',
      quota_exceed: 'Quota cannot exceed {quota}',
      area_required: 'Area must be selected',
      seller_required: 'Seller must be selected',
      customer_category_required: 'Customer Category must be selected',
      customer_required: 'Customer must be selected',
      product_type_required: 'Product Type must be selected',
      product_item_required: 'Product Item must be selected',
      product_category_required: 'Product Category must be selected',
      product_brand_required: 'Product Brand must be selected',
      reason_required: 'A reason for cancelling the promo must be selected / filled',
      promotion_list_empty: 'Promotion List cannot be empty',
    },
    discount_list: 'Discount List',
    detail_discount: 'Discount Detail',
    edit_discount: 'Edit Discount',
    add_discount: 'Add Discount',
    duplicate_discount: 'Duplicate Discount',
    area: 'Area',
    seller: 'Seller',
    seller_description: 'Define sellers based on area and seller',
    customer: 'Customer',
    customer_category: 'Customer Category',
    customer_description: 'Define customers based on category and customer',
    search_select_area: 'Search & Select Area',
    select_all_area: 'Select All Area',
    search_select_seller: 'Search & Select Seller',
    select_all_seller: 'Select All Seller',
    select_all_category: 'Select All Category',
    search_select_customer_category: 'Search & Select Customer Category',
    search_select_customer: 'Search & Select Customer',
    select_all_customer: 'Select All Customer',
    search_select_product_category: 'Search & Select Product Category',
    search_select_product_brand: 'Search & Select Product Brand',
    add_promotion: 'Add Promotion',
    add_gift: 'Add Gift',
  },
  voucher: {
    voucher: 'Voucher',
    createvoucher: 'Create Voucher',
    latest: 'Latest Data',
    allstatus: 'All',
    search: 'Search Voucher',
    sort: 'Sort',
    waiting: 'Waiting for Approval',
    active: 'Active',
    nonactive: 'Non Active',
    codeTypeVoucher: 'Kode & Type Voucher',
    create_voucher: 'Create Voucher',
    edit_voucher: 'Edit Voucher',
    voucher_lists: 'Voucher Lists',
    voucher_name: 'Voucher Name',
    voucher_code: 'Voucher Code',
    voucher_get: 'Period to get Voucher',
    voucher_usage: 'Period to use Voucher',
    same_period: 'Same with Voucher validity',
    voucher_combined: 'Voucher can be combined',
    edit: 'Edit Voucher',
    promo_cancellation: 'Voucher Cancellation',
    cancellation_description:
      'By canceling the {value} Voucher, the voucher will be inactive and cannot be used',
    choose_cancellation: 'Choose a reason to cancel this voucher',
    write_reason: 'Write other reasons here',
    inactive: 'Canceled',
    add_voucher: 'Add Voucher',
    edit_voucher: 'Edit Voucher',
    detail_voucher: 'Detail Voucher',
    customer: 'Customer',
    seller: 'Seller',
    seller_target_desc: 'Determine sellers based on area and seller',
    area: 'Area',
    search_select_area: 'Search & Select Area',
    select_all_area: 'Select All Area',
    search_select_seller: 'Search & Select Seller',
    select_all_seller: 'Select All Seller',
    customer_target_desc: 'Determine customers based on category and customer',
    customer_category_label: 'Customer Category',
    search_select_customer_category: 'Search & Select Customer Category',
    select_all_customer_category: 'Select All Category',
    search_select_customer: 'Search & Select Customer',
    select_all_customer: 'Select All Customer',
    search_select_category: 'Search & Select Product Category',
    search_select_brand: 'Search & Select Product Brand',
    add_promotion: 'Add Promotion',
    edit: 'Edit',
    delete: 'Delete',
    error_promotion_required: 'Promotion list cannot be empty',
    success: 'Success',
    success_create: 'Voucher successfully created',
    failed: 'Failed',
    error_403_create: 'You do not have access to create Voucher',
    failed_create: 'Voucher failed to be created',
    rule_area_required: 'Area must be selected',
    rule_seller_required: 'Seller must be selected',
    rule_customer_category_required: 'Customer Category must be selected',
    rule_customer_required: 'Customer must be selected',
    rule_product_type_required: 'Product Type must be selected',
    rule_product_item_required: 'Product Item must be selected',
    rule_product_category_required: 'Product Category must be selected',
    rule_product_brand_required: 'Product Brand must be selected',
    duplicate_voucher_error: 'Voucher code is already available. Please check the voucher list to avoid duplicates',
  },
  redeem: {
    redeem_product: 'Redeem Product',
    search: 'Search Product',
    stock: 'Stock',
    redeem_count: 'Numbers of Redeem',
    minimum: 'Minimum',
    maximum: 'Maximum',
    reset_filter: 'Reset Filter',
    apply: 'Apply',
    category: 'Category',
    variant: 'Variant',
    status: 'Status',
    sku: 'SKU',
    coin: 'Coin',
    times: 'Times',
  },
  addDiscount: {
    basic: 'Basic Details',
    programName: 'Program Name',
    startDate: 'Start Date',
    endDate: 'End Date',
    promotionType: 'Promotion Type',
    rate: 'Discount Rate',
    target: 'Promotion Target',
    area: 'Area',
    distributor: 'Distributor',
    shopType: 'Shop Type',
    shop: 'Shop',
    programType: 'Program Type',
    productType: 'Product Type',
    settingPromo: 'Promotion Setting',
    itemProduct: 'Item Product',
    kuota: 'Promotion Quota',
    typeBuy: 'Program & Purchase Type',
    format: 'Discount Format',
    nilaiPromosi: 'Promotion Value',
    promotion: 'Promotion',
    addPromotion: 'Add Promotion',
    purchaseRange: 'Purchase Range',
    promotionFormat: 'Promotion Format',
  },
  addVoucher: {
    basic: 'Basic Details',
    voucherName: 'Voucher Name',
    voucherCode: 'Voucher Code',
    startDate: 'Start Date',
    endDate: 'End Date',
    voucherType: 'Voucher Type',
    rate: 'Discount Rate',
    target: 'Promotion Target',
    area: 'Area',
    distributor: 'Distributor',
    shopType: 'Shop Type',
    shop: 'Shop',
    cutype: 'Cutting Type',
    productType: 'Product Type',
    settingVoucher: 'Promotion Voucher',
    itemProduct: 'Item Product',
    kuota: 'Promotion Quota',
    typeBuy: 'Program & Purchase Type',
    format: 'Discount Format',
    nilaiPromosi: 'Promotion Value',
    periode: 'Period',
    addPromotion: 'Add Promotion',
    purchaseRange: 'Purchase Range',
    promotionFormat: 'Promotion Format',
    usageQuota: 'Usage Quota',
    minimumReq: 'Minimum Requirement',
  },
  finance: {
    list_transfer: 'List of Transfer',
    search: 'Search Transfer',
    pay_number: 'Pay Number',
    method: 'Method',
    total_bill: 'Total Bill',
    rest_of_bill: 'Rest Of Bill',
    payment_deadline: 'Request Date',
    payment_status: 'Payment Status',
    invoice_number: 'No. Invoice',
    customer_name: 'Customer Name',
    order_number: 'No. Order',
    payment_confirm: 'Payment Confirm',
    payment_reject: 'Payment Reject',
    transaction_detail: 'Transaction Detail',
    order_id: 'Order ID',
    transaction_date: 'Transaction Date',
    bill_amount: 'Bill Amount',
    discount_use: 'Discount Use',
    point_use: 'Point Use',
    payment_date: 'Payment Date',
    payment_type: 'Payment Type',
    bank_name: 'Bank Name',
    account_number: 'Account Number',
    transfer_evidence: 'Transfer Evidence',
    input_payment: 'Payment Amount',
    mistake: 'Mistake',
    select_mistake: 'Select Mistake',
    expired_date: 'Expired Date',
    payment_amount: 'Payment Amount',
    need_confirmation: 'Need Confirmation',
    confirmed: 'Confirmed',
    waiting: 'Need Confirmation',
    cancelled: 'Cancelled',
    rejected: 'Rejected',
    outstanding: 'Outstanding',
    confirm_transfer: 'Confirm Transfer',
    payment_history: 'Payment History',
    create_payment: 'Create Payment',
    total_pay: 'Total Payment',
    pay_date: 'Payment Date',
    pay_method: 'Payment Method',
    pay_name: 'Payment Name',
    order_detail: 'Order Detail',
    create: 'Create',
    account_name: 'Account Name',
    payout_bank_name: 'Payout Bank Name',
    payout_account_number: 'Payout Account Number',
    payout_account_name: 'Payout Account Name',
    selectSeller: 'Select seller',
    selectSellerFirst: 'Please select seller first',
    distributor: 'Distributor',
    order: 'Order',
    paymentTerm: 'Payment Term',
    errorOccurred: 'An error occurred',
    failedLoadDistributor: 'Failed to load distributor seller data',
    nominalRequired: 'Nominal cannot be empty',
    nominalMismatch: 'Nominal cannot be less or more than total bill',
    mistakeOptions: {
      option1: 'Payment received, wrong proof',
      option2: 'Payment not received, correct proof',
      option3: 'Payment not received, wrong proof',
    },
    statusOptions: {
      all: 'All',
      needConfirmation: 'Need Confirmation',
      confirmed: 'Confirmed',
      cancelled: 'Cancelled',
      rejected: 'Rejected',
    },
    payment_type_bank_transfer: 'Bank Transfer',
  },
  withdrawal: {
    distributor_wallet: 'Distributor Wallet',
    withdraw_wallet: 'Withdraw Wallet',
    history_wallet: 'History Wallet',
    estimated_balance: 'Estimated next total balance',
    disclaimer_balance: 'The total balance value above does not include other applicable fees',
    total_balance: 'Total Balance',
    withdrawal_history: 'Withdrawal History',
    request_date: 'Request Date',
    nominal: 'Nominal',
    date: 'Date',
    status: 'Status',
    request_id: 'Request ID',
    bank_details: 'Bank Details',
    bank_name: 'Bank Name',
    bank_account: 'Bank Account',
    account_number: 'Account Number',
    account_name: 'Account Name',
    benificiary_name: 'Benificiary Name',
    processing_date: 'Processing Date',
    withdrawal_form: 'Withdrawal Form Request',
    withdrawal_amount: 'Withdrawal Amount',
    minimum_withdrawal: 'Minimum withdrawal',
    withdrawal_fee: 'Withdrawal fee',
    data_correct: 'All data is correct',
    select_bank: 'Select Bank',
    all: 'All',
    draft: 'Draft',
    confirmed: 'Approved',
    canceled: 'Canceled',
    completed: 'Completed',
    approved: 'Approved',
    rejected: 'Rejected',
    process: 'Process',
    select: 'Select',
    processed: 'Processed',
    failed: 'Failed',
    terms1: '* Maximum withdrawal {max_frequency}x in {frequency_time_value} {frequency_time_unit}',
    terms2: '* Transfer process will be performed maximum 2x24 hours after request is sent',
    terms3: '* Minimum withdrawal {min_amount} and maximum withdrawal {max_amount}',
    text_min_amount: 'Minimum withdrawal {min_amount}',
    text_max_amount: 'Maximum withdrawal {max_amount}',
    month: 'month(s)',
    week: 'week(s)',
    day: 'day(s)',
    error_amount_exceed_balance: 'Withdrawal amount cannot be more than the Balance',
    add_bank: 'Add Bank',
  },
  helpdesk_page: {
    title: 'Is there anything we can help with?',
    info: `If you need assistance, please contact CS Kino Siap \nat the mobile number or email address listed.`,
  },
  error: {
    CL_NOT_ELIGIBLE: '',
    CL_INSUFFICIENT: 'Credit Limit Balance not enough',
    CL_EXCEED_MULTIPLEBOND: 'Oportunity for debt is over',
    CL_OVERDUE: 'Credit Limit Transaction with status Waiting is Overdue',
    WP_NOT_FOUND: 'No Waiting Payment Transaction Found',
  },
  tiktok: {
    categoryMaster: 'Product Master Category',
    categoryTiktok: 'Product Tiktok Category',
    categoryShopee: 'Product Shopee Category',
    categoryToco: 'Product Toco Category',
    description:
      'Upload size chart that the product has. Minimum photo dimensions are {minWidth}x{minHeight} px. The maximum file size is 1MB. With JPG, JPEG, PNG, BMP, GIF formats.',
    garansi: 'Warranty Period',
    policy: 'Warranty Policy',
  },
  adjustment: {
    stock: 'Stock Adjustment',
    create: 'Create Adjustment',
    id: 'Adjustment ID',
    date: 'Adjustment Date',
    type: 'Adjustment Type',
    search: 'Search Adjustment',
    detail: 'Detail Adjustment',
    chooseType: 'Choose Adjustment Type',
    note: 'Notes',
    see_more: 'See more',
    detailItem: 'Detail Product Item',
    addItem: 'Add Item',
    stockAvailable: 'Stock Available',
    stockChanges: 'Stock Changes',
    stockAfterChange: 'Stock After Change',
    adjust: 'Adjust',
    sync: 'Sync Stock',
    choose_sync_warehouse: 'Select warehouses whose stock will be synchronized',
    all_warehouse: 'All Warehouse',
    is_syncing: 'Currently synchronizing',
    last_sync: 'Last sync',
    actor: 'Excecuted By',
    adjustIn: 'Adjust In',
    adjustOut: 'Adjust Out',
    bulkImport: 'Bulk Item Import',
    notValidData: 'Some data is not valid',
    importSuccess: 'All Data Successfully Imported',
    qtyExceed: 'Cannot exceed Available Stock',
    itemExist: 'Item already exists',
    importItems: 'Import Items',
    uploading: 'Uploading file...',
    uploadExcel: 'Upload your excel file here',
    downloadTemplateHint: 'If you do not have an import items file template, please click the download file button in the bottom left.',
    submitItems: 'Submit All Items',
    revisedListTitle: 'List Revised Imported Items',
    skuNotFound: 'SKU not found',
    uomNotValid: 'UOM not valid',
    dataNotValid: 'Data not valid',
    closeNoDownload: 'Close Without Download',
    closeDownloadRevised: 'Close and Download List Revised',
    revisedStatus: 'Revised Status',
  },
  channel: {
    category: {
      default: 'Channel Category',
      tiktok: 'Tiktok Product Category',
      tiktok_id: 'Tiktok Product Category',
      tokopedia_id: 'Tokopedia Product Category',
      shopee_id: 'Shopee Product Category',
      toco_id: 'Toco Product Category',
    },
    product: {
      tiktok: 'Tiktok Product',
      tiktok_id: 'Tiktok Product',
      tokopedia_id: 'Tokopedia Product',
      shopee_id: 'Shopee Product',
      toco_id: 'Toco Product',
    },
  },

  po: {
    title: 'Manage Inbound Delivery',
    create: 'Create Inbound Delivery',
    search_placeholder: 'Search Inbound Delivery No...',
    sort_po_date_newest: 'Inbound Delivery Date, Newest',
    sort_po_date_oldest: 'Inbound Delivery Date, Oldest',
    sort_created_at_newest: 'Created Date, Newest',
    sort_created_at_oldest: 'Created Date, Oldest',
    sort_number_asc: 'Inbound Delivery Number, A-Z',
    sort_number_desc: 'Inbound Delivery Number, Z-A',
    sort_supplier_asc: 'Supplier Inbound Delivery, A-Z',
    sort_supplier_desc: 'Supplier Inbound Delivery, Z-A',
    create_gr: 'Create GR',
    cancel: 'Cancel Inbound Delivery',
    cancel_confirm: 'Yes, cancel Inbound Delivery',
    cancel_success: 'Inbound Delivery successfully canceled',
    cancel_description: 'Are you sure you want to cancel this Inbound Delivery?',
    created: 'Created',
    partial_received: 'Partial Received',
    full_received: 'Received',
    unreceived: 'Unreceived',
    canceled: 'Cancelled',
    columns: {
      number: 'Inbound Delivery Number',
      po_date: 'Inbound Delivery Date',
      supplier_do: 'Delivery Order Number',
      delivery_date: 'Delivery Date',
      supplier: 'Supplier',
      warehouse: 'Warehouse',
      created_by: 'Created By',
      created_at: 'Created Date',
      status: 'Status',
      detail_po: 'Inbound Delivery Detail',
      qty_po: 'Inbound Delivery Qty',
      uom_po: 'Inbound Delivery UOM',
      qty_gr: 'Qty GR',
      qty_received: 'Received Qty',
    },
    detail_title: 'Inbound Delivery Detail',
    loading_detail: 'Please wait, fetching Inbound Delivery data...',
    loading_create: 'Please wait, creating Inbound Delivery...',
    input_po_number: 'Enter Inbound Delivery number',
    input_po_date: 'Enter Inbound Delivery date',
    input_delivery_number: 'Enter delivery order number',
    input_delivery_date: 'Enter delivery date',
    select_supplier: 'Select supplier',
    select_warehouse: 'Select warehouse',
    no_supplier_found: 'cannot find supplier?',
    add_supplier: 'Add Supplier',
    select_warehouse_warning: 'Please select warehouse before adding product',
    error_failed_create: 'Sorry, failed to create Inbound Delivery.',
    error_no_product: 'Please add at least 1 product.',
    error_qty_empty: 'Product quantity cannot be empty.',
    error_batch_empty: 'Batch Number cannot be empty.',
    error_expired_empty: 'Expired Date cannot be empty.',
    success_created: 'Inbound Delivery Successfully Created',
    batch_no: 'Batch No.',
    expired_date: 'Expired Date',
    stock_type: 'Stock Type',
    po_number_required: 'Inbound Delivery Number is required',
    po_date_required: 'Inbound Delivery Date is required',
    delivery_date_required: 'Delivery Date is required',
    supplier_required: 'Supplier is required',
    warehouse_required: 'Warehouse is required',
    revised_list: 'Revised Item List',
    close_no_download: 'Close without Download',
    close_download_revised: 'Close and Download Revised Item List',
    repush_to_javelin: 'Repush to Javelin',
    repush_to_javelin_success: 'Repush to Javelin Success',
    repush_to_javelin_failed: 'Repush to Javelin Failed',
  },
  transferStock: {
    title: 'Stock Transfer',
    detailTitle: 'Stock Transfer - Detail',
    createTitle: 'Stock Transfer - Create Request',
    createButton: 'Create Stock Transfer',
    searchPlaceHolder: 'Number',
    optionGudang: 'Select Warehouse',
    sortByNewest: 'Newest Date',
    sortByOldest: 'Oldest Date',
    columns: {
      date: 'Date',
      number: 'Transfer Number',
      referenceNumber: 'Reference Number',
      sourceWarehouse: 'Source Warehouse',
      destinationWarehouse: 'Destination Warehouse',
      sender: 'Sender',
      receiver: 'Receiver',
      status: 'Status',
      no: 'No',
      catalog: 'SKU/Catalog',
      unit: 'Unit',
      quantity: 'Qty',
      qtyAvailable: 'Qty Available',
      qtyTransfer: 'Qty Transfer',
      qtyShipped: 'Qty Shipped',
      qtyReceived: 'Qty Received',
    },
    actions: {
      viewDetail: 'View Detail',
      send: 'Send',
      receive: 'Receive',
      cancel: 'Cancel',
      printSJ: 'Print Delivery Note',
    },
    labels: {
      detailCardTitle: 'Transfer Detail',
      itemCardTitle: 'Transfer Items',
      numberLabel: 'Transfer No.',
      referenceNumberLabel: 'Reference No.',
      dateLabel: 'Date',
      warehouseFromLabel: 'Warehouse (From)',
      warehouseToLabel: 'Warehouse (To)',
      noteLabel: 'Note',
      createdAt: 'Created At',
      createdBy: 'Created By',
      sentAt: 'Sent At',
      senderLabel: 'Sender',
      receiptAt: 'Received At',
      receiverLabel: 'Receiver',
      sortBy: 'Sort By',
    },
    filters: {
      startDate: 'Start Date',
      endDate: 'End Date',
    },
    datePresets: {
      today: 'Today',
      thisMonth: 'This Month',
      thisYear: 'This Year',
      last7Days: 'Last 7 Days',
      last30Days: 'Last 30 Days',
      last1Year: 'Last 1 Year',
    },
    itemColumns: {
      no: 'No',
      catalog: 'SKU/Catalog',
      quantity: 'Qty',
      unit: 'Unit',
      qtyReceived: 'Qty Received',
    },
    messages: {
      copy: 'Copy',
      copySuccess: 'Transfer number copied',
      copyError: 'Failed to copy transfer number',
      copyReferenceSuccess: 'Reference number copied',
      copyReferenceError: 'Failed to copy reference number',
      warningSelectWarehouse: 'Select Warehouse To Make Transfer Stock',
    },
    confirm: {
      sendTitle: 'Send Confirmation',
      sendContent: 'Are you sure you want to send transfer {value}?',
      receiveTitle: 'Receive Confirmation',
      receiveContent: 'Are you sure you want to receive transfer {value}?',
      cancelTitle: 'Cancel Confirmation',
      cancelContent: 'Are you sure you want to cancel transfer {value}?',
      okSend: 'Yes, Send',
      okReceive: 'Yes, Receive',
      okCancel: 'Yes, Cancel',
      cancelText: 'No',
      changeWarehouseTitle: 'Change Warehouse?',
      changeWarehouseContent: 'Changing the warehouse will clear all currently entered items. Do you want to continue?',
    },
    success: {
      send: 'Transfer sent successfully',
      receive: 'Transfer received successfully',
      cancel: 'Transfer canceled successfully',
    },
    error: {
      send: 'Failed to send transfer',
      receive: 'Failed to receive transfer',
      cancel: 'Failed to cancel transfer',
      qtyExceeded: 'Quantity exceeds available stock in source warehouse',
      qtyExceededOnSubmit: 'Cannot save: some items exceed available stock',
      qtyNegative: 'Quantity cannot be negative',
      availabilityNegative: 'Available stock is negative, item is invalid',
      availabilityNegativeOnSubmit: 'Cannot save: items with negative stock present',
      forbiddenSource: 'You do not have access to this source warehouse',
      forbiddenDestination: 'You do not have access to this destination warehouse',
    },
    placeholders: {
      selectProduct: 'Select Product',
      noteOptional: 'Add description (optional)',
      referenceNumberOptional: 'Enter reference number',
      driverName: 'Driver Name',
      vehicleNumber: 'Vehicle Number',
    },
    buttons: {
      addRow: 'Add Item',
      saveTransfer: 'Save Transfer',
      search: 'Search',
      importTitle: 'Import Stock Transfer',
      import: {
        uploadTab: 'Upload',
        historyTab: 'Import History',
        step1Title: '1. Download Template',
        step1Desc: 'Download the Excel file template to fill in the transfer stock data to be imported.',
        downloadButton: 'Download Template',
        downloadFile: 'Download File',
        step2Title: '2. Upload File',
        step2Desc: 'Upload the Excel file filled according to the template. Supported formats: .xlsx, .xls',
        uploadPlaceholder: 'Click or drag file to this area to upload',
        uploadHint: 'Only supports single file upload at a time.',
        processing: 'Processing...',
        startImport: 'Start Import',
        successTitle: 'Import Successful',
        failedTitle: 'Import Failed',
        totalRows: 'Total Rows',
        successCount: 'Success',
        failedCount: 'Failed',
        downloadProcessFile: 'Download Process File',
        errorDetail: 'Error Detail',
        lines: 'lines',
        transferNumber: 'Transfer Number',
        noTransfer: 'Transfer No.',
        row: 'Row',
        errorMessage: 'Error Message',
        allDataSuccess: 'All data successfully imported.',
        noDetail: 'No details to display.',
        notifications: {
          downloadTemplateError: 'Failed to Download Template',
          downloadTemplateDesc: 'An error occurred while downloading the template.',
          uploadSuccess: 'Upload successful, processing data...',
          uploadError: 'Upload Failed',
          uploadErrorData: 'There are errors in the import file data. Please check the error details.',
          uploadErrorFile: 'An error occurred while uploading the file.',
          importFailed: 'Import Process Failed',
          importFailedDesc: 'Please check the error details.',
          importSuccess: 'Import Process Completed',
          downloadFileError: 'Failed to Download File',
          downloadFileDesc: 'An error occurred while downloading the file.',
          loadDetailError: 'Failed to Load Detail',
          loadDetailDesc: 'An error occurred.',
        },
        columns: {
          items: 'Items',
          totalRows: 'Total Rows',
          success: 'Success',
          failed: 'Failed',
          status: 'Status',
          action: 'Action',
          row: 'Row',
          noTransfer: 'Transfer No.',
          sku: 'SKU',
          errorMessage: 'Error Message',
        },
      },
    },
    print: {
      title: 'Delivery Note',
      paperSize: 'Paper Size',
      print: 'Print',
      close: 'Close',
      sender: 'Sender',
      receiver: 'Receiver',
      admin: 'Admin',
      driver: 'Driver',
      vehicleNumber: 'Vehicle Number',
      driverName: 'Driver Name',
    },
  },
  utils: {
    refresh: 'Refresh',
    copy: 'Copy',
    try_again: 'Try Again',
    loading: 'Loading data...',
    back: 'Back',
    select: 'Select',
    choose: 'Choose',
    accept: 'Accept',
    reject: 'Reject',
    not_set: 'Not set',
    filter: 'Filter',
    cancel: 'Cancel',
    remove: 'Remove',
    failed: 'Failed',
    bulk_actions: 'Bulk Actions',
    save: 'Save',
    discard: 'Discard',
    edit: 'Edit',
    add: 'Add',
    price: 'Price',
    add_product: 'Add Product',
    apply: 'Apply',
    variable: 'Variable',
    search: 'Search',
    search_placeholder: 'No Order / SKU',
    insert: 'Insert',
    use: 'Use',
    step: 'Step {step}',
    downloadTemplate: 'Download Template',
    successData: 'Success Data',
    failedData: 'Failed Data',
    totalData: 'Total Data',
    submit: 'Submit',
    start: 'Start',
    end: 'End',
    items_per_page: 'Items per page',
    close: 'Close',
    show: 'Show',
    hide: 'Hide',
    success_save: 'Data successfully saved',
    failed_save: 'Failed to save data, please try again.',
    error_occurred: 'Something went wrong',
    all: 'All',
    categories: 'Category',
    channel: 'Channel',
    date: 'Date',
    quantity: 'Quantity',
    sku: 'SKU',
    example: 'Example',
    name: 'Name',
    price: 'Price',
    currency: 'Currency',
    idr: 'IDR',
    wrong: 'Something went wrong',
    used: 'already used',
    yes: 'Yes',
    no: 'No',
    rules: {
      bank_required: 'Bank must be selected',
      account_number_required: 'Account Number is required, must contain at least 7 characters',
      account_name_required: 'Account Name is required, must contain at least 3 characters',
      data_match_required: 'Matching data must be selected',
      area_required: 'Area must be selected',
      customer_type_required: 'Customer Type must be selected',
      price_required: 'Price is required',
      uom_required: 'Unit must be selected',
      effective_date_required: 'Effective Date must be selected',
    },
    confirm_delete: 'Do you sure want to delete',
    change: 'Change',
    choose_a_tag: 'Choose a tag',
    choose_a_channel: 'Choose a channel',
    choose_a_warehouse: 'Choose a warehouse',
    choose_a_service: 'Choose priority',
    schedule: 'Schedule',
    clearFilter: 'Clear Filter',
    reload: 'Reload',
    export: 'Export',
    status: 'Status',
    hour: 'Jam',
    not_found: 'Not Found',
    amount: 'Amount',
    quantity: 'Quantity',
    uom: 'UoM',
    failed: 'Failed',
    success: 'Success',
    delete: 'Delete',
    deleted: 'Deleted',
    close: 'Close',
    formula: 'Formula',
    pagination_show_total: 'Showing {perpage} from {total} items',
    pagination_show_range: 'Showing {start} - {end} of {total} items',
    items_per_page: '/ page',
    order_date: 'Order Date',
    no_data: 'No data',
    view_detail: 'View Detail',
    close_detail: 'Close Detail',
    view_history: 'View History',
    close_history: 'Close History',
    times: 'Times',
    days: 'Days',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    isRequired: 'is required',
  },
  web_platform: {
    product: {
      list_title: 'Web Commerce Product',
      deactivate_title: 'Deactivate Product',
      deactivate_desc: 'Are you sure you want to deactivate this product?',
      view_detail: 'View Detail',
      edit_product: 'Edit Product',
      create_product: 'Create Product',
      search_product: 'Search Product',
      change_status_title: 'Change Product Status',
      confirm_status_change_prefix: 'Are you sure you want to',
      deactivate_action: 'deactivate',
      activate_action: 'activate',
      confirm_status_change_suffix: 'this product?',
      cancel: 'Cancel',
      yes: 'Yes',
      status_update_success: 'Product status successfully updated',
      status_update_failed: 'Failed to update product status, please try again.',
      update_failed: 'Update failed, try again!',
      sync_failed: 'Product sync failed, try again.',
      sync_success: 'Product successfully synchronized',
      draft: {
        have_draft: 'You have product draft',
        draft_desc: 'To create new product you can continue with draft or create new',
        continue_draft: 'Continue Draft',
        delete_draft: 'Delete Draft and Create New',
        product_not_found: 'Product not found',
        error_occurred: 'Error occurred',
      },
      messages: {
        try_again_later: 'Try again later',
        sku_already_registered: 'SKU Code {sku} has been registered to another product',
        product_save_failed: 'Oops, product failed to save!',
        changes_saved: 'Changes successfully saved',
        draft_saved: 'Product draft successfully saved',
        images_saved: 'Product images successfully saved',
        images_save_failed: 'Oops, product images failed to save',
        catalog_save_failed: 'Oops, product catalog failed to save',
        shipping_save_failed: 'Oops, product weight and shipping failed to save',
        product_saved: 'Product successfully saved!',
        invalid_fields: 'Some fields are invalid, please fill them in first',
        unsaved_data: 'Unsaved Data',
        confirm_leave_draft: 'Are you sure you want to close this page? Filled data will not be saved',
        confirm_leave_edit: 'Changes will be lost when you leave this page',
        yes_leave: 'Yes, Leave this page',
      },
    },
    reseller: {
      title: 'Reseller',
      search: 'Search Reseller',
      confirm_register: 'Confirmation Register',
      view_detail: 'View Detail',
      total_items: 'Total {total} items',
      update_level: 'Update Level Model',
      seller_confirmation: 'Seller Register Confirmation',
      select_level: 'Select Level Model',
      level_required: 'Level model is required',
      success_update_level: 'Success update level models',
      success_confirm_register: 'Seller register confirmation success',
      columns: {
        name: 'Name',
        store_name: 'Store Name',
        email: 'Email Address',
        phone: 'Phone Number',
        level: 'Level',
        status: 'Status',
      },
      detail: {
        user_data: 'USER DATA',
        firstname: 'Firstname:',
        name: 'Name:',
        email: 'Email:',
        phone: 'Phone:',
        address_data: 'ADDRESS DATA',
        address_line_1: 'Address Line 1',
        address_line_2: 'Address Line 2',
        subdistrict: 'Subdistrict:',
        district: 'District:',
        city: 'City:',
        province: 'Province:',
        image_data: 'IMAGE DATA',
      },
    },
    promotion: {
      title: 'Promotion',
      add_voucher: 'Add New Voucher',
      edit_voucher: 'Edit Voucher',
      search_result: 'Search Result',
      voucher_code: 'Voucher Code',
      select_date_range: 'Please select range date time',
      search: 'Search',
      desc_percentage: 'Disc {value}% off entire order. With minimum transaction {min}. Maximum discount {max}.',
      desc_amount: 'Disc {value} off entire order. With minimum transaction {min}. Maximum discount {max}.',
      availability: 'Availability:',
      total: 'Total:',
      available: 'Available:',
      used: 'Used:',
      booked: 'Booked:',
      voucher_period: 'Voucher Period',
      list_product_discount: 'List Product to Discount:',
      courier_discount: 'Courier to Discount:',
      brand_discount: 'Brand to Discount:',
      type: {
        transaction: 'Transaction Voucher',
        product: 'Product Item Voucher',
        shipping: 'Shipping Voucher',
        brand: 'Brand Voucher',
      },
      product_count: '({count} product)',
      delete_confirm: 'Do you want to delete these voucher? {value}',
      status: {
        expired: 'expired',
        coming_soon: 'coming soon',
        running: 'running',
      },
    },
  },
  promotion: {
    title: 'Promotion',
    promotion_name: 'Promotion Name',
    promotion_list: 'Promotion List',
    add_promotion: 'Add Promotion',
    edit_promotion: 'Edit Promotion',
    add_item: 'Add Item',
    bulk_import: 'Bulk Item Import',
    import_items: 'Import Items',
    wait_uploading: 'Uploading file...',
    upload_excel_placeholder: 'Upload your excel file here',
    download_template_hint: 'If you do not have an import items template file yet, please click the download file button at the bottom left.',
    submit_all_items: 'Submit All Items',
    duplicate_sku_list: 'Duplicate SKU List',
    revised_item_list: 'Revised Item List',
    close_without_download: 'Close without Download',
    close_and_download_revised: 'Close and Download Revised Item List',
    error_sku_not_found: 'SKU not found',
    error_duplicate_sku: 'duplicate SKU',
    error_uom_invalid: 'UOM invalid',
    error_data_invalid: 'Data invalid',
    error_price_invalid: 'Price invalid',
    error_end_date_after_start: 'Discount end time must be after start time',
    error_date_overlap: 'There is another promotion during this period, please select another period or deactivate other promotions during that period',
    sync_promotion: 'Sync',
    syncing_promotion: 'Syncing process...',
    view_product: 'View product',
    promotion_date: 'Promotion Date',
    end_date: 'End Date',
    sync_date: 'Sync Date',
    deactivate: 'Deactivate',
    delete_promotion: 'Delete Promotion',
    delete_confirm: 'Are you sure you want to delete promotion: {name}?',
    delete_success: 'Promotion successfully deleted',
    sync_process_title: 'Synchronization in progress',
    sync_process_desc: 'Please wait, syncing promo: {name}',
    sync_success: 'Synchronization successful',
    sync_failed: 'Synchronization failed',
    deactivate_title: 'Deactivate Promotion',
    deactivate_confirm_desc: 'Are you sure you want to deactivate promotion:',
    deactivate_wait_msg: 'Please wait, deactivating promotion:',
    deactivate_success: 'Promotion successfully deactivated',
    deactivate_failed: 'Something went wrong, failed to deactivate promotion',
    deactivate_btn_confirm: 'Yes, Deactivate',
    active: 'Active',
    inactive: 'Inactive',
    upcoming: 'Upcoming',
    draft: 'Draft',
    expired: 'Expired',
    ongoing: 'Ongoing',
    period: 'Period',
    status: 'Status',
    action: 'Action',
    promotion_info: 'Promotion Information',
    promotion_code: 'Promotion Code',
    placeholder_promotion_code: 'Enter promotion code',
    start_date: 'Start Date',
    placeholder_start_date: 'Enter start date',
    placeholder_end_date: 'Enter end date',
    period_required: 'Please input a voucher period',
    product_info: 'Product Information',
    batch_edit: 'Batch Edit',
    batch_edit_desc: 'Set to change all <b>discount percentage</b> and <b>purchase limit</b>',
    discount_nominal: 'Discount Nominal',
    placeholder_discount_nominal: 'Enter discount nominal',
    discount_percentage: 'Discount Percentage',
    placeholder_discount_percentage: 'Enter discount percentage',
    apply_all: 'Apply All',
    not_eligible_date: 'Product is not available for the selected date.',
    no_stock: 'This product has no stock.',
    all_products_shown: 'All products have been displayed',
    loading_products: 'Loading products...',
    unlimited: 'Unlimited',
    confirm_edit: 'Confirm Edit',
    confirmation: 'Confirmation',
    mandatory_date_range: 'Please select start and end date before adding products.',
    change_date_confirm: 'Are you sure you want to change the {type} date?',
    change_date_desc: 'This change will affect the eligibility of all products you have added.',
    yes_change_date: 'Yes, change {type} date',
    wait_fetching_detail: 'Please wait, fetching promotion data...',
    wait_updating: 'Please wait, updating promotion...',
    wait_creating: 'Please wait, creating promotion...',
    failed_fetch_detail: 'Failed to get latest promotion data',
    failed_add_product_desc: 'Add products first, at least 1 product.',
    error_fill_discount: 'Please enter a discount value in nominal or percentage.',
    promo_code_required: 'Promotion code is required',
    start_date_required: 'Start date is required',
    start_date_after_now: 'Start date must be after current time',
    start_date_after_prev: 'The new start date must be after the previously set start date. Previous time: {date}',
    end_date_required: 'End date is required',
    end_date_after_start: 'End date must be after start date',
    end_date_min_1hour: 'End date must be at least 1 hour after start date',
    end_date_before_prev: 'The new end date must be before the previously set end date. Previous time: {date}',
    discount_exclusive: 'Only one of nominal or percentage discount can be filled',
    discount_too_high: 'Discount nominal cannot be greater than the cheapest price, the current cheapest price is: {price}',
    apply_discount_success: 'Successfully applied discount',
    apply_discount_failed: 'Failed to apply discount, discount type not found',
    discount_limit_error: 'Discount nominal cannot be greater than the original price, the maximum discount price is currently: {price}',
    import_success_all: 'All {count} data successfully imported',
    import_success_partial: '{fail} data failed to import, {success} data successfully imported',
    import_failed_all: 'All data failed to import',
    columns: {
      product_name: 'Product Name',
      original_price: 'Original Price',
      discount_price: 'Discount Price',
      discount: 'Discount',
      promo_stock: 'Promotion Stock',
      purchase_limit: 'Purchase Limit',
    },
    add_voucher: 'Add New Voucher',
    edit_voucher: 'Edit Voucher',
    search_result: 'Search Result',
    voucher_code: 'Voucher Code',
    voucher_code_help: 'Customer will enter this discount code at checkout',
    voucher_code_required: 'Please input your voucher code!',
    voucher_type: 'Voucher Type',
    voucher_type_required: 'Please select your voucher type!',
    voucher_type_placeholder: 'Select Voucher Type',
    select_date_range: 'Please select range date time',
    search: 'Search',
    select_products: 'Select Products to Get Voucher',
    products_required: 'Please select your products!',
    select_product: 'Select Product',
    select_courier: 'Select Courier',
    courier_required: 'Please select courier',
    select_brands: 'Select Brands',
    select_brand: 'Select Brand',
    discount_type: 'Discount Type',
    discount_type_required: 'Please select discount type',
    percentage: 'Percentage',
    fixed_amount: 'Fixed Amount',
    fixed_amount_idr: 'Fixed Amount (IDR)',
    discount_value: 'Discount Value',
    discount_value_error: 'Discount value must be a number',
    quantity_voucher: 'Quantity Voucher',
    quantity_error: 'Quantity value must be a number',
    min_transaction: 'Minimum Transaction',
    min_transaction_error: 'Minimum transaction must be a number',
    max_discount: 'Maximum Discount',
    max_discount_error: 'Maximum Discount must be a number',
    placeholder_voucher_code: 'e.g. PROMO-KEMERDEKAAN',
    period_required: 'Please input a voucher period',
    voucher_combined: 'Voucher can combined?',
    option_required: 'Please check this option',
    set_all_store: 'Set Voucher To All Store',
    select_stores: 'Select Stores to Get Voucher',
    stores_required: 'Please select store list',
    select_store: 'Select Store',
    max_discount_greater_error: 'maximum discount cant be greater than the discounted value',
    max_discount_less_error: 'maximum discount cant be less than the discounted value',
    desc_percentage: 'Disc {value}% off entire order. With minimum transaction {min}. Maximum discount {max}.',
    desc_amount: 'Disc {value} off entire order. With minimum transaction {min}. Maximum discount {max}.',
    availability: 'Availability:',
    total: 'Total:',
    available: 'Available:',
    used: 'Used:',
    booked: 'Booked:',
    voucher_period: 'Voucher Period',
    list_product_discount: 'List Product to Discount:',
    courier_discount: 'Courier to Discount:',
    brand_discount: 'Brand to Discount:',
    type: {
      transaction: 'Transaction Voucher',
      product: 'Product Item Voucher',
      shipping: 'Shipping Voucher',
      brand: 'Brand Voucher',
    },
    product_count: '({count} product)',
    delete_confirm: 'Do you want to delete these voucher? {value}',
    status_labels: {
      expired: 'expired',
      coming_soon: 'coming soon',
      running: 'running',
    },
    detail: {
      voucher_code: 'Voucher Code',
      voucher_type: 'Voucher Type',
      voucher_value: 'Voucher Value',
      min_transaction: 'Minimum Transaction',
      max_discount: 'Max Discount',
      orders_using_voucher: 'List of orders using vouchers',
      order_number: 'Order Number',
      status: 'Status',
      date: 'Date',
      order_status: {
        waiting_payment: 'Waiting Payment',
        new: 'New',
        on_process: 'On Process',
        sent: 'Sent',
        delivered: 'Delivered',
        completed: 'Completed',
        canceled: 'Canceled',
        cancel_request: 'Cancel Request',
      },
    },
    error: {
      voucher_unused: 'Voucher has never been used!',
    },
  },
  returChannel: {
    list_retur: 'Return List',
    list_pengajuan_retur: 'Return Request List',
    pilih_warehouse: 'Select Warehouse',
    semua: 'All',
    selesai: 'Completed',
    ditolak: 'Rejected',
    menunggu_konfirmasi: 'Waiting Confirmation',
    dalam_proses: 'In Process',
    dibatalkan: 'Canceled',
    draft: 'Draft',
    no_pengajuan_retur: 'Return Request No.',
    distributor: 'Distributor',
    tanggal_pengajuan: 'Request Date',
    pelanggan: 'Customer',
    status: 'Status',
    aksi: 'Action',
    detail_pengajuan_retur: 'Return Request Detail',
    nama_pelanggan: 'Customer Name',
    total_nilai_retur: 'Total Return Value',
    total_koin_retur: 'Total Return Coin',
    tolak_pengajuan: 'Reject Request',
    reject_request_title: 'Reject Return Request',
    req_qty: 'Req QTY',
    app_qty: 'App QTY',
    terima: 'Accept',
    proses: 'Process',
    ya_tolak: 'Yes, Reject',
    batalkan: 'Cancel',
    alasan_penolakan: 'Rejection Reason',
    masukan_alasan: 'Enter Rejection Reason',
    min_char_reason: 'Min 5 characters and max 75 characters',
    ubah_status: 'Change Return Status',
    confirm_finish: 'Are you sure you want to finish this return request?',
    confirm_reject_needed: 'You need to reject the request if there is no return on the product.',
    ya_terima: 'Yes, Accept',
    ya_selesaikan: 'Yes, Finish',
    nama_produk: 'Product Name',
    harga_retur: 'Return Price',
    nilai_koin: 'Coin Value',
    total: 'Total',
    total_pengembalian: 'Total Refund',
    reason: 'Reason',
    req_qty_desc: 'requested item quantity',
    app_qty_desc: 'approved item quantity',
    damaged_product: 'Damaged or broken product',
    expired_product: 'Product nearing expiration',
    other_reason: 'Other',
  },
  creditNotes: {
    page_title: 'Credit Notes',
    create_button: 'Create Credit Notes',
    form_title: 'Credit Notes Request Form',
    modal_detail_title: 'Credit Notes Request Form',
    update_status_title: 'Update Credit Notes Status',
    placeholder_warehouse: 'Select Warehouse',
    tab_all: 'All',
    tab_requested: 'Requested',
    tab_approved: 'Approved',
    tab_rejected: 'Rejected',
    tab_canceled: 'Canceled',
    column_cn_number: 'Credit Notes No.',
    column_distributor: 'Distributor',
    column_request_date: 'Request Date',
    column_withdrawal: 'Withdrawal',
    column_status: 'Status',
    label_distributor_name: 'Distributor Name',
    label_date: 'Date',
    label_withdrawal_amount: 'Input Withdrawal Point',
    helper_amount: 'You will get IDR amount ..........',
    note_term_condition: 'Terms & Conditions :',
    note_1: '* You can claim Minimum .........point & maximum ..............point',
    note_2: '* Credit Note can be requested maximum ................. times in .....................',
    note_3: '* Process will be done maximum 2x24 Hours',
    submit_button: 'Submit',
    cancel_button: 'Cancel',
    reject_button: 'Reject',
    accept_button: 'Accept',
    finish_button: 'Yes, Finish',
    confirm_finish_desc: 'Are you sure you want to finish this Credit Notes request?',
    reject_title: 'Reject Request',
    cancel_title: 'Cancel Request',
    reject_reason: 'Rejection Reason',
    cancel_reason: 'Cancellation Reason',
    placeholder_reason: 'Enter Reason',
    yes_reject: 'Yes, Reject',
    yes_cancel: 'Yes, Cancel',
    detail_name: 'Name',
    detail_coin_kino: 'Kino Coin',
    detail_coin_withdrawal: 'Withdrawal Coin',
    detail_rupiah: 'Rupiah',
    total: 'Total',
  },
  invoice: {
    invoice_detail: 'Invoice Detail',
    print_invoice: 'Print Invoice',
    invoice_title: 'INVOICE',
    issued_by: 'ISSUED BY',
    seller: 'Seller',
    for: 'FOR',
    buyer: 'Buyer',
    address: 'Address',
    phone_number: 'Phone Number',
    product: 'PRODUCT',
    quantity: 'QUANTITY',
    unit_price: 'UNIT PRICE',
    total_price: 'TOTAL PRICE',
    total_price_count: 'TOTAL PRICE ({count} PRODUCT)',
    coin: 'Coin',
    credit_limit: 'Credit Limit',
    return_deposit: 'Return Deposit',
    shipping_cost: 'Shipping Cost',
    vat: 'VAT',
    price_include_vat: '*) Price includes VAT',
    courier: 'Courier',
    payment_method: 'Payment Method',
    invoice_footer_text: 'This invoice is legal and processed by computer. Please contact <span style="color: red">Customer Service </span> <br /> if you need assistance',
    list_invoice: 'Invoice List',
    invoice_number: 'Invoice No.',
    order_date: 'Order Date',
    total_bill: 'Total Bill',
    payment_status: 'Payment Status',
    order_number: 'Order No.',
    customer_name: 'Customer Name',
    payment_due_date: 'Payment Due Date',
    send: 'Send',
    export_excel: 'Export Excel',
    start_date: 'Start Date',
    end_date: 'End Date',
    today: 'Today',
    this_month: 'This Month',
    this_year: 'This Year',
    last_7_days: 'Last 7 Days',
    last_30_days: 'Last 30 Days',
    last_1_year: 'Last 1 Year',
    paid: 'Paid',
    canceled: 'Canceled',
    unpaid: 'Unpaid',
    declined: 'Declined',
    expired: 'Expired',
    error_title: 'Error Occurred',
    error_select_warehouse: 'Please select warehouse first before exporting invoice data.',
    error_empty_data: 'Empty Data',
    error_filter_date: 'No data based on that date filter.',
    error_load_data: 'Failed to load data.',
  },
  paymentHistory: {
    page_title: 'Payment History',
    placeholder_seller: 'Select seller',
    alert_select_seller: 'Select seller first',
    create_payment: 'Create Payment',
    column_payment_number: 'Payment No.',
    column_total_payment: 'Total Payment',
    column_payment_date: 'Payment Date',
    column_payment_method: 'Payment Method',
    column_payment_name: 'Payment Name',
    column_order_number: 'Order No.',
    column_invoice_number: 'Invoice No.',
    column_due_date: 'Due Date',
    column_outstanding: 'Outstanding',
    column_payment: 'Payment',
    column_remaining_outstanding: 'Remaining Outstanding',
    column_status: 'Status',
    sort_oldest: 'Oldest Date',
    sort_newest: 'Newest Date',
    label_total_bill: 'Total Bill',
    label_total_order_paid: 'Total Paid Orders',
    link_view: 'View',
    placeholder_search_order: 'Search Order No.',
    error_total_payment_empty: 'Total Payment cannot be empty',
    error_total_payment_match: 'Total Payment must match Total Bill',
    success_payment_created: 'Payment successfully created',
    error_payment_created: 'Payment failed to create',
    warning_already_paid: 'Bill for order number {orderNumber} is already paid',
    error_order_canceled: 'Order number {orderNumber} cannot be processed because it is Canceled',
    copied_success: 'Copied {type}: {value}',
    error_load_distributor: 'Failed to load distributor seller data',
    error_load_seller: 'Failed to get seller data',
    error_seller_not_found: 'Seller data not found',
    error_export_data: 'Failed to Export Data',
    export_filename: 'Payment History',
    export_payment_id: 'Payment ID',
    export_total_paid: 'Total Paid',
    export_account_number: 'Account No.',
    export_order_id: 'Order ID',
    export_order_date: 'Order Date',
  },

  currency: {
    idr: 'Indonesian Rupiah',
    myr: 'Malaysian Ringgit',
  },

  dashboard: {
    total_order_text: 'Total Order',
    total_orders: '{value} order|{value} orders',
    orders: {
      tooltip: '{value} pesanan|{value} pesanan',
    },

    order_status: {
      title: 'Transaction Status',
      description: 'Summary of delivery order transaction status to date that you need to follow up',
      new: 'New',
      on_process: 'On Process',
      ready_to_ship: 'Ready to Ship',
      cancel_requested: 'Cancellation Request',
    },

    connected_store: {
      title: 'Store Connected',
      description: 'Total store connected.',
    },

    pending_po: {
      title: 'Pending Inbound',
      description: 'Total pending inbound delivery.',
    },

    oos_item: {
      title: 'Out of Stock',
      description: 'Total item out of stock.',
    },

    inventory_item: {
      title: 'Total SKU',
      description: 'Total SKU in inventory.',
    },

    today_summary: 'Summary for Today',


    nmv: {
      title: 'Total NMV',
      tooltip: 'NMV: {value}',
      abv: {
        short: 'ABV: {n}',
        long: 'Average NMV per transaction: {n}',
      },
    },
    gmv: {
      title: 'Total GMV',
      tooltip: 'GMV: {value}',
      abv: {
        short: 'ABV: {n}',
        long: 'Average GMV per transaction: {n}',
      },
    },
    logistic: {
      title: 'Logistic Spend',
      als: {
        short: 'ALS: {n}',
        long: 'Average Logistic Spend per transaction: {n}',
      },
    },

    statistics_overview: 'Report',
    today: 'Today',
    last_n_days: 'Last {n} days',
    mtd: 'This month',
    last_month: 'Last month',
    ytd: 'This year',
    n_year: '{n} year',
    last_year: 'Last year',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    item_sold_count: '{label} Item Sold|{label} Items sold',
    item_sold: 'Item Sold',
    item_sold_desc: 'Total item sold',

    top_business_title: 'Business',
    top_business_subtitle: 'Top 10 Businesses',
    
    top_sales_channel_title: 'Sales Channel',
    top_sales_channel_subtitle: 'Top 10 sales channels',

    top_channel_title: 'Channel',
    top_channel_subtitle: 'Top 10 channels',

    top_warehouse_title: 'Warehouse',
    top_warehouse_subtitle: 'Top 10 warehouses',

    top_area_title: 'Shipping Area',
    top_area_subtitle: 'Top 10 most popular shipping areas',
    top_area_empty: 'No order placed yet.',
    area_selector: {
      province: 'Province',
      city: 'City',
    },

    top_product_title: 'Product',
    top_product_subtitle: 'Top 10 most popular products',
    product_selector: {
      product: 'Product',
      catalog: 'Product Variant',
    },
    top_product_empty: 'No product sold yet.',
    new_version_welcome_message: `<h4>Welcome to the New Dashboard</h4>
        
            <p>You’re currently using our redesigned dashboard, created to provide a cleaner and more intuitive experience.</p>`,
    new_version_welcome_message_link: 'Click here to switch back to the old dashboard.',
  },
}

export const localeAntd = antd
